
// Fonction utilitaire pour envoyer des messages WhatsApp via Maytapi
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut, updatePassword , createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc,addDocs, setDoc, updateDoc, collection, addDoc,onSnapshot, getDocs,Timestamp , deleteDoc, query, where, orderBy } from 'firebase/firestore';
import { db, secondaryAuth } from '../components/firebase-config.js';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import cld from '../components/cloudinary-config.js';
import AffiliationRequestsManager from './AffiliationRequestsManager.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
  faHome, faUserMd, faUser, faCalendarAlt, faArchive, 
  faLink, faKey, faBars, faPlus, faArrowLeft, faArrowRight, faUserPlus, 
  faCalendarPlus, faSignOutAlt, faPlusCircle, faFilter, faEdit, faTrash, 
  faClock, faCheck, faTimes, faExclamationTriangle, faFile, faSearch, 
  faChevronLeft, faChevronRight, faPhone, faEnvelope, faCalendarDay, 
  faCalendarWeek, faCalendarCheck, faExchangeAlt, faEye, faBolt, 
  faInfoCircle, faSpinner, faSync, faFileAlt, faDownload, faFileWord, 
  faFileExcel, faFilePowerpoint, faFilePdf, faVideo, faMusic ,faList,
  faPaperclip, faFileImage, faBell
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './StructureDashboard.css';

import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { Modal, Button, Form, Carousel } from 'react-bootstrap';

// Ajouter la configuration Maytapi après les imports existants
const MAYTAPI_CONFIG = {
  PRODUCT_ID :'5e994f76-4f49-4057-aca4-6bef3b1de795', // À remplacer par votre Product ID Maytapi
  API_TOKEN : 'a0b5ba45-b4da-429e-ba5b-127851d9b92e', // À remplacer par votre token API Maytapi
  PHONE_ID :'77695' // À remplacer par votre Phone ID Maytapi
} 
// Fonction utilitaire pour envoyer des messages WhatsApp via Maytapi
const sendWhatsAppMessage = async (phoneNumber, message) => {
  try {
    console.log("⏳ Préparation de l'envoi WhatsApp...");
    console.log("📱 Numéro de téléphone:", phoneNumber);
    
    // Formater le numéro de téléphone pour WhatsApp si nécessaire
    if (!phoneNumber) {
      console.error("❌ Numéro de téléphone manquant!");
      return { success: false, error: "Numéro de téléphone manquant" };
    }
    
    let formattedNumber = phoneNumber;
    // Retirer tous les espaces, tirets et parenthèses
    formattedNumber = formattedNumber.replace(/[\s\-()]/g, '');
    
    // S'assurer que le numéro commence par +
    if (!formattedNumber.startsWith('+')) {
      // Si le numéro commence par un 0, le remplacer par le code pays
      if (formattedNumber.startsWith('0')) {
        formattedNumber = '+221' + formattedNumber.substring(1);
      } else {
        // Sinon, simplement ajouter le code pays
        formattedNumber = '+221' + formattedNumber;
      }
    }
    
    console.log("📞 Numéro formaté:", formattedNumber);
    console.log("💬 Message à envoyer:", message);
    
    // Vérifier la configuration Maytapi
    if (!MAYTAPI_CONFIG.PRODUCT_ID || !MAYTAPI_CONFIG.PHONE_ID || !MAYTAPI_CONFIG.API_TOKEN) {
      console.error("❌ Configuration Maytapi incomplète:", MAYTAPI_CONFIG);
      return { success: false, error: "Configuration Maytapi incomplète" };
    }
    
    // Configurer la requête pour l'API Maytapi
    console.log("🔄 Envoi de la requête à Maytapi...");
    console.log("📊 Configuration API:", {
      productId: MAYTAPI_CONFIG.PRODUCT_ID,
      phoneId: MAYTAPI_CONFIG.PHONE_ID,
      // Ne pas logger le token API pour des raisons de sécurité
    });
    
    const response = await axios.post(
      `https://api.maytapi.com/api/${MAYTAPI_CONFIG.PRODUCT_ID}/${MAYTAPI_CONFIG.PHONE_ID}/sendMessage`,
      {
        to_number: formattedNumber,
        type: 'text',
        message: message
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-maytapi-key': MAYTAPI_CONFIG.API_TOKEN
        }
      }
    );
    
    console.log("✅ Réponse reçue de Maytapi:", response.data);
    
    if (response.status === 200 && response.data.success) {
      console.log("🎉 Message WhatsApp envoyé avec succès!");
      return { success: true, data: response.data };
    } else {
      console.error("❌ Échec de l'envoi du message. Réponse API:", response.data);
      throw new Error(response.data.message || "Échec de l'envoi du message");
    }
  } catch (error) {
    console.error("❌ Erreur lors de l'envoi du message WhatsApp:", error);
    // Afficher plus de détails sur l'erreur
    if (error.response) {
      console.error("📡 Détails de la réponse d'erreur:", {
        status: error.response.status,
        data: error.response.data
      });
    }
    return { success: false, error: error.message };
  }
};

// Fonction pour envoyer une notification de rendez-vous
const sendAppointmentNotification = async (appointment, notificationType = 'confirmation') => {
  try {
    const { patientNom, patientTelephone, date, heure, medecinNom, motif } = appointment;
    
    // Formater la date pour une meilleure lisibilité
    const formattedDate = new Date(date).toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    
    let message = '';
    
    switch (notificationType) {
      case 'confirmation':
        message = `Bonjour ${patientNom},\n\nVotre rendez-vous a été confirmé pour le ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMotif: ${motif || 'Consultation'}\n\nMerci de votre confiance.`;
        break;
      case 'reminder':
        message = `Bonjour ${patientNom},\n\nNous vous rappelons votre rendez-vous demain ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMerci de confirmer votre présence.`;
        break;
      case 'cancellation':
        message = `Bonjour ${patientNom},\n\nNous vous informons que votre rendez-vous du ${formattedDate} à ${heure} avec ${medecinNom} a été annulé.\n\nVeuillez nous contacter pour plus d'informations ou pour reprogrammer.`;
        break;
      case 'rescheduled':
        message = `Bonjour ${patientNom},\n\nVotre rendez-vous a été reprogrammé pour le ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMotif: ${motif || 'Consultation'}\n\nMerci de votre compréhension.`;
        break;
      default:
        message = `Bonjour ${patientNom},\n\nInformation concernant votre rendez-vous du ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMerci de nous contacter pour plus de détails.`;
    }
    
    // Envoyer le message WhatsApp
    return await sendWhatsAppMessage(patientTelephone, message);
  } catch (error) {
    console.error('Erreur lors de l\'envoi de la notification de rendez-vous:', error);
    return { success: false, error: error.message };
  }
};

const StructureDashboard = () => {
  const [structureData, setStructureData] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [form, setForm] = useState({});
  const [activeTab, setActiveTab] = useState('rendezvous');
  const [medecins, setMedecins] = useState([]);
  const [patients, setPatients] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  const [showMedecinForm, setShowMedecinForm] = useState(false);
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [showRendezvousForm, setShowRendezvousForm] = useState(false);
  const [currentMedecin, setCurrentMedecin] = useState(null);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [currentRendezvous, setCurrentRendezvous] = useState(null);
  const [filtreDate, setFiltreDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  });
  
  const [filtreMedecin, setFiltreMedecin] = useState('');
  const [archives, setArchives] = useState([]);
  const [showArchiveForm, setShowArchiveForm] = useState(false);
  const [currentArchive, setCurrentArchive] = useState(null);
  const [archiveFiles, setArchiveFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filtreArchivePatient, setFiltreArchivePatient] = useState('');
  const [pendingRequests, setPendingRequests] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);
  



// Fonction pour générer un mot de passe aléatoire
const generateRandomPassword = (length = 6) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
  let password = '';
  
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  
  return password;
};



  // État du formulaire d'archive
  const [archiveForm, setArchiveForm] = useState({
    patientId: '',
    titre: '',
    description: '',
    notes: '',
    date: new Date().toISOString().split('T')[0],
    tags: [],
    files: []
  });
  
  // Constantes
  const tagsList = ["Consultation", "Examen", "Ordonnance", "Analyse", "Radiologie", "Hospitalisation", "Chirurgie", "Suivi", "Autre"];
  const storage = getStorage();
  
  // État du formulaire médecin
  const [medecinForm, setMedecinForm] = useState({
    nom: '',
    prenom: '',
    specialite: '',
    telephone: '',
    email: '',
    password: '',
    disponibilites: {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    },
    assurances: []
  });
  
  // État du formulaire patient
  const [patientForm, setPatientForm] = useState({
    nom: '',
    prenom: '',
    dateNaissance: '',
    email: '',
    password: '',
    telephone: '',
    assurances: [],
    diagnostics: '' // Ajout du champ diagnostics
  });
  
  
  // État du formulaire rendez-vous
  const [rdvForm, setRdvForm] = useState({
    medecinId: '',
    patientId: '',
    date: new Date().toISOString().split('T')[0],
    heure: '08:00',
    duree: 5,
    motif: '',
    statut: 'confirmé'
  });
  
  // Constantes
  const specialites = [ 
    "Cardiologie",
    "Réadaptation Cardiovasculaire",
    "Chirurgie Cardio-Vasculaire",
    "Pneumologie - Spirométrie",
    "Gastro-Entérologie & Endoscopie Digestive",
    "Pédiatrie - Endocrinologie",
    "Nutrition - Nutrithérapie",
    "Diabétologie",
    "Gynécologie",
    "Anesthésie & Réanimation",
    "Dermatologie",
    "Rhumatologie",
    "Cancérologie",
    "Hématologie",
    "Urologie",
    "Orthopédie",
    "Gériatrie",
    "Médecine Physique & Rééducation",
    "Ostéopathie",
    "Laboratoire d'Analyses Médicales",
    "Échographie",
    "Psychiatrie & Addictologie",
    "Psychologie Clinique",
    "Thérapie Capillaire et Cognitivo-Comportementale",
    "Kinésithérapie",
    "Sport de Remise en Forme / Yoga",
    "Ophtalmologie générale",
    "Chirurgie réfractive",
    "Chirurgie de la cataracte",
    "Rétinologie",
    "Glaucome",
    "Ophtalmologie pédiatrique",
    "Neuro-ophtalmologie",
    "Cornée et surface oculaire",
    "Contactologie",
    "Autre"
  
  ];
    
    
  const assurancesList = ["CNAM", "CNSS", "CNRPS", "Assurance privée", "Autre",
    "Sanlam", "AXA", "NSIA", "Saham Assurance", "Leadway Assurance",
    "Mutuelle des Fonctionnaires", "SONAM", "Allianz", "Liberty Mutual",
    "Activa Assurance", "SUNU Assurances", "GA Insurance", "MUA Insurance",
    "Fidelity Insurance", "Old Mutual", "Hollard Insurance", "Ecobank Assurances",
    "Prudential", "Afric Assistance", "ASKIA Assurances", "BICIS Assurances",
    "UGB Assurance", "AMO Assurance"];
    
  const joursSemaine = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  const statutsRdv = [ "confirmé", "terminé", "annulé"];
  const dureesRdv = [15, 30, 45, 60, 90, 120];
  
  // États pour la vue calendrier
  const [calendarView, setCalendarView] = useState('month');
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showMedecinRdvModal, setShowMedecinRdvModal] = useState(false);
  const [selectedMedecinId, setSelectedMedecinId] = useState(null);
  const [showRdvDetailsModal, setShowRdvDetailsModal] = useState(false);
  const [selectedRdv, setSelectedRdv] = useState(null);
  const [draggedRdv, setDraggedRdv] = useState(null);
    // Variables d'état pour l'interface mobile
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showMobileActionMenu, setShowMobileActionMenu] = useState(false);
    const [mobileDetailView, setMobileDetailView] = useState(null);
    const [mobileSearchActive, setMobileSearchActive] = useState(false);
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [showMedecinRdvs, setShowMedecinRdvs] = useState(false);

    const [quickRequests, setQuickRequests] = useState([]);
    const [showQuickRequestsModal, setShowQuickRequestsModal] = useState(false);
    const [selectedQuickRequest, setSelectedQuickRequest] = useState(null);
    const [assignMedecinModal, setAssignMedecinModal] = useState(false);
    const [selectedMedecinForQuick, setSelectedMedecinForQuick] = useState('');
    const [quickRequestsCount, setQuickRequestsCount] = useState(0);
    
    const [selectedFile, setSelectedFile] = useState(null);
    const [showFilePreview, setShowFilePreview] = useState(false);
    const [loading, setLoading] = useState(false);

    const [demandesRapides, setDemandesRapides] = useState([]);
    const [activeTabRdv, setActiveTabRdv] = useState('attente');
    const [demandesAcceptees, setDemandesAcceptees] = useState([]);
    const [loadingAcceptees, setLoadingAcceptees] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [pendingDoctorRequests, setPendingDoctorRequests] = useState([]);
    const [affiliationRequests, setAffiliationRequests] = useState([]);

  const navigate = useNavigate();
  const auth = getAuth();

  // Gestion de la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
      if (window.innerWidth < 999) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Remplacer les fonctions fetch par des écouteurs temps réel
  const setupRealtimeListeners = (structureId) => {
    // Écouteur pour les médecins
    const unsubscribeMedecins = onSnapshot(
      query(collection(db, 'medecins'), where("structureId", "==", structureId)),
      (snapshot) => {
        const medecinsData = [];
        snapshot.forEach((doc) => {
          medecinsData.push({ id: doc.id, ...doc.data() });
        });
        setMedecins(medecinsData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des médecins:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les patients
    const unsubscribePatients = onSnapshot(
      query(collection(db, 'patients'), where("structureId", "==", structureId)),
      (snapshot) => {
        const patientsData = [];
        snapshot.forEach((doc) => {
          patientsData.push({ id: doc.id, ...doc.data() });
        });
        setPatients(patientsData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des patients:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les rendez-vous
    const unsubscribeRendezvous = onSnapshot(
      query(collection(db, 'rendezvous'), where("structureId", "==", structureId)),
      (snapshot) => {
        const rdvData = [];
        snapshot.forEach((doc) => {
          const rdv = doc.data();
          if (rdv.date) {
            const dateObj = new Date(rdv.date);
            if (!isNaN(dateObj.getTime())) {
              rdv.date = formatDateString(dateObj);
            }
          }
          rdvData.push({ id: doc.id, ...rdv });
        });
        setRendezvous(rdvData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des rendez-vous:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les demandes rapides
    const unsubscribeQuickRequests = onSnapshot(
      query(
        collection(db, 'quickAppointments'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setQuickRequests(requests);
        setQuickRequestsCount(requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes rapides:", error);
      }
    );

    // Écouteur pour les demandes d'affiliation
    const unsubscribeAffiliationRequests = onSnapshot(
      query(
        collection(db, 'affiliationRequests'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setPendingDoctorRequests(requests);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes d'affiliation:", error);
      }
    );

    // Écouteur pour les archives
    const unsubscribeArchives = onSnapshot(
      query(collection(db, 'archives'), where("structureId", "==", structureId)),
      (snapshot) => {
        const archivesData = [];
        snapshot.forEach((doc) => {
          archivesData.push({ id: doc.id, ...doc.data() });
        });
        setArchives(archivesData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des archives:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Retourner une fonction de nettoyage pour tous les écouteurs
    return () => {
      unsubscribeMedecins();
      unsubscribePatients();
      unsubscribeRendezvous();
      unsubscribeQuickRequests();
      unsubscribeAffiliationRequests();
      unsubscribeArchives(); // Ajouter cette ligne
    };
  };

  // Modifier le useEffect principal pour utiliser les écouteurs temps réel
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, 'structures', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          
          // Mettre en place les écouteurs temps réel
          const unsubscribeListeners = setupRealtimeListeners(user.uid);
          
          // Nettoyer les écouteurs lors du démontage
          return () => {
            unsubscribeListeners();
          };
        } else {
          navigate('/auth');
        }
      } else {
        navigate('/auth');
      }
    });

    // Nettoyer l'écouteur d'authentification lors du démontage
    return () => {
      unsubscribeAuth();
    };
  }, [auth, navigate]);



  
    // Fonction pour déterminer le type de contenu d'un fichier
    const getFileType = (file) => {
      if (!file || !file.url) return 'unknown';
      
      const url = file.url.toLowerCase();
      if (url.match(/\.(jpeg|jpg|png|gif|webp)$/)) return 'image';
      if (url.match(/\.(pdf)$/)) return 'pdf';
      if (url.match(/\.(mp4|webm|mov)$/)) return 'video';
      if (url.match(/\.(mp3|wav|ogg)$/)) return 'audio';
      if (url.match(/\.(doc|docx)$/)) return 'word';
      if (url.match(/\.(xls|xlsx)$/)) return 'excel';
      if (url.match(/\.(ppt|pptx)$/)) return 'powerpoint';
      if (url.match(/\.(txt)$/)) return 'text';
      return 'other';
    };

     // Fonction pour l'aperçu des fichiers
  const renderFilePreview = (file) => {
    const fileType = getFileType(file);
    
    switch (fileType) {
      case 'image':
        return (
          <img 
            src={file.url} 
            alt={file.name} 
            className="img-fluid mx-auto d-block" 
            style={{ maxHeight: '70vh' }}
          />
        );
      case 'pdf':
        return (
          <div className="text-center">
            <iframe 
              src={file.url} 
              width="100%" 
              height="500" 
              className="border-0"
              title={file.name}
            ></iframe>
          </div>
        );
        case 'video':
          return (
            <div className="text-center">
              <video 
                src={file.url} 
                controls 
                className="img-fluid" 
                style={{ maxHeight: '70vh' }}
              />
            </div>
          );
        case 'audio':
          return (
            <div className="text-center mt-4">
              <audio 
                src={file.url} 
                controls 
                className="w-100" 
              />
            </div>
          );
        default:
          return (
            <div className="text-center p-5">
              <div className="display-1 mb-3">
                <FontAwesomeIcon 
                  icon={
                    fileType === 'word' ? faFileWord : 
                    fileType === 'excel' ? faFileExcel : 
                    fileType === 'powerpoint' ? faFilePowerpoint : 
                    faFile
                  } 
                />
  </div>
            <h4>{file.name}</h4>
            <p className="text-muted mb-4">Ce type de fichier ne peut pas être prévisualisé</p>
            <Button 
              variant="primary" 
              href={file.url} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Télécharger
            </Button>
          </div>
        );
    }
  };
  // Récupérer les demandes d'affiliation en attente
  const fetchPendingRequests = async (structureId) => {
    try {
      // Récupérer les demandes d'affiliation des médecins
      const medecinRequestsQuery = query(
        collection(db, 'affiliationRequests'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const medecinSnapshot = await getDocs(medecinRequestsQuery);
      const medecinRequests = [];
      medecinSnapshot.forEach((doc) => {
        medecinRequests.push({ id: doc.id, ...doc.data() });
      });
      setPendingDoctorRequests(medecinRequests);

      // Récupérer les demandes d'affiliation des patients
      const patientRequestsQuery = query(
        collection(db, 'affiliations'),
        where("structureId", "==", structureId),
        where("statut", "==", "en attente")
      );
      const patientSnapshot = await getDocs(patientRequestsQuery);
      const patientRequests = [];
      patientSnapshot.forEach((doc) => {
        patientRequests.push({ id: doc.id, ...doc.data() });
      });
      setAffiliationRequests(patientRequests);
    } catch (error) {
      console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const fetchArchives = async (structureId) => {
    try {
      const q = query(collection(db, 'archives'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const archivesData = [];
      querySnapshot.forEach((doc) => {
        archivesData.push({ id: doc.id, ...doc.data() });
      });
      setArchives(archivesData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des archives: ${error.message}`);
    }
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = useCallback(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    
    const days = [];
    
    // Ajouter les jours du mois précédent pour compléter la première semaine
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);
      
      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter(rdv => {
        // S'assurer que les dates sont comparées dans le même format
        return rdv.date === dateString;
      });
      
      // Obtenir les médecins uniques qui ont des rendez-vous ce jour
      const uniqueMedecins = [...new Set(dayEvents.map(rdv => rdv.medecinId))];
      
      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        medecinCount: uniqueMedecins.length,
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const totalDaysToShow = 42; // 6 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    return days;
  }, [currentMonth, rendezvous]);
  

 const formatDateString = (date) => {
  if (!date) return '';
  
  // S'assurer que date est un objet Date
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    console.error('Date invalide:', date);
    return '';
  }
  
  // Format YYYY-MM-DD
  return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
};

// Fonction pour afficher la date en format lisible (DD/MM/YYYY)
const formatDate = (date) => {
  if (!date) return '';
  
  // S'assurer que date est un objet Date
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    console.error('Date invalide:', date);
    return '';
  }
  
  // Format DD/MM/YYYY
  return `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${dateObj.getFullYear()}`;
};

  // Récupération des données
  const fetchMedecins = async (structureId) => {
    try {
      const q = query(collection(db, 'medecins'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const medecinsData = [];
      querySnapshot.forEach((doc) => {
        medecinsData.push({ id: doc.id, ...doc.data() });
      });
      setMedecins(medecinsData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des médecins: ${error.message}`);
    }
  };

  const fetchPatients = async (structureId) => {
    try {
      const q = query(collection(db, 'patients'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const patientsData = [];
      querySnapshot.forEach((doc) => {
        patientsData.push({ id: doc.id, ...doc.data() });
      });
      setPatients(patientsData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des patients: ${error.message}`);
    }
  };

  const fetchRendezvous = async (structureId) => {
    try {
      const q = query(collection(db, 'rendezvous'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const rdvData = [];
      
      for (const doc of querySnapshot.docs) {
        const rdv = doc.data();
        const formattedRdv = {
          id: doc.id,
          ...rdv,
          // Formater la date si elle existe
          date: rdv.date ? formatDateString(new Date(rdv.date)) : '',
          // S'assurer que les noms sont correctement formatés
          medecinNom: rdv.medecinNom || 'Non assigné',
          patientNom: rdv.patientNom || 'Patient inconnu',
          // Ajouter des champs par défaut si manquants
          duree: rdv.duree || '30',
          motif: rdv.motif || 'Consultation',
          statut: rdv.statut || 'en attente',
          // Formater les timestamps
          createdAt: rdv.createdAt ? new Date(rdv.createdAt.toDate()).toLocaleString() : '',
          updatedAt: rdv.updatedAt ? new Date(rdv.updatedAt.toDate()).toLocaleString() : ''
        };
        
        // Si le rendez-vous provient d'une demande rapide, s'assurer que toutes les informations sont présentes
        if (rdv.source === 'quick') {
          formattedRdv.patientEmail = rdv.patientEmail || rdv.email || '';
          formattedRdv.patientTelephone = rdv.patientTelephone || rdv.telephone || '';
          formattedRdv.verificationCode = rdv.verificationCode || '';
        }
        
        rdvData.push(formattedRdv);
      }
      
      setRendezvous(rdvData);
    } catch (error) {
      setMessage(`Erreur lors de la récupération des rendez-vous: ${error.message}`);
    }
  };
  

  // Fonctions générales
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/auth');
  };

  const handleUpdate = async () => {
    try {
      const user = auth.currentUser;
      await updateDoc(doc(db, 'structures', user.uid), form);
      setMessage('Informations mises à jour avec succès.');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage('Mot de passe mis à jour avec succès.');
      setNewPassword('');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Gestion des formulaires d'archive
  const handleArchiveChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "tags") {
      const updatedArray = [...archiveForm.tags];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setArchiveForm({ ...archiveForm, [name]: updatedArray });
    } else {
      setArchiveForm({ ...archiveForm, [name]: value });
    }
  };
  
  const resetArchiveForm = () => {
    setArchiveForm({
      patientId: '',
      titre: '',
      description: '',
      notes: '',
      date: new Date().toISOString().split('T')[0],
      tags: [],
      files: []
    });
    setSelectedFiles([]);
    setCurrentArchive(null);
  };
  
  const handleFileChange = (e) => {
    if (e.target.files) {
      setSelectedFiles(Array.from(e.target.files));
    }
  };
  
  const handleAddArchive = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      const fileUrls = [];
      
      // Uploader les fichiers sélectionnés avec Cloudinary
      if (selectedFiles.length > 0) {
        for (const file of selectedFiles) {
          // Créer un FormData pour l'upload vers Cloudinary
          const formData = new FormData();
          formData.append('file', file);
          formData.append('upload_preset', 'fichiers');
          formData.append('folder', `archives/${user.uid}`);
          
          // Envoyer le fichier à Cloudinary
          const response = await fetch(
            `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`,
            {
              method: 'POST',
              body: formData,
            }
          );
          
          const data = await response.json();
          
          if (response.ok) {
            fileUrls.push({ 
              id: data.public_id,
              name: file.name, 
              type: file.type,
              size: file.size,
              url: data.secure_url,
              public_id: data.public_id,
              uploadedAt: new Date()
            });
          } else {
            throw new Error(`Erreur lors du téléversement: ${data.error?.message || 'Erreur inconnue'}`);
          }
        }
      }
      
      // Récupérer les informations du patient
      const patient = patients.find(p => p.id === archiveForm.patientId);
      
      const archiveData = {
        ...archiveForm,
        patientNom: patient ? `${patient.prenom} ${patient.nom}` : '',
        files: currentArchive ? [...archiveForm.files, ...fileUrls] : fileUrls,
        structureId: user.uid,
        createdAt: new Date()
      };
      
      if (currentArchive) {
        // Mise à jour d'une archive existante
        await updateDoc(doc(db, 'archives', currentArchive.id), {
          ...archiveData,
          updatedAt: new Date()
        });
      } else {
        // Création d'une nouvelle archive
        await addDoc(collection(db, 'archives'), archiveData);
      }
      
      resetArchiveForm();
      setShowArchiveForm(false);
      setMessage('Archive ' + (currentArchive ? 'mise à jour' : 'ajoutée') + ' avec succès.');
      
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  
  const handleEditArchive = (archive) => {
    setCurrentArchive(archive);
    setArchiveForm({
      patientId: archive.patientId || '',
      titre: archive.titre || '',
      description: archive.description || '',
      notes: archive.notes || '',
      date: archive.date || new Date().toISOString().split('T')[0],
      tags: archive.tags || [],
      files: archive.files || []
    });
    setShowArchiveForm(true);
  };
  
  const handleDeleteArchive = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette archive ?')) {
      try {
        // Récupérer l'archive pour obtenir les chemins des fichiers
        const archiveDoc = await getDoc(doc(db, 'archives', id));
        const archiveData = archiveDoc.data();
        
        // Supprimer les fichiers du stockage
        if (archiveData.files && archiveData.files.length > 0) {
          for (const file of archiveData.files) {
            if (file.path) {
              const fileRef = ref(storage, file.path);
              await deleteObject(fileRef);
            }
          }
        }
        
        // Supprimer le document de l'archive
        await deleteDoc(doc(db, 'archives', id));
        setMessage('Archive supprimée avec succès.');
        
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };
  
  const handleDeleteFile = async (archiveId, file, fileIndex) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce fichier ?')) {
      try {
        setLoading(true);
        
        // Si le fichier est sur Cloudinary (a un public_id)
        if (file.public_id) {
          // Utiliser l'API de destruction sécurisée de Cloudinary
          const timestamp = Math.round(new Date().getTime() / 1000);
          const apiKey = '328927441826894';
          
          // Note: Ceci est une requête de suppression simplifiée, en production utilisez
          // un backend pour générer la signature et effectuer l'appel de manière sécurisée
          const response = await fetch('/api/cloudinary/delete', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              public_id: file.public_id,
            }),
          });
          
          // Si nous n'avons pas d'API backend, nous mettons à jour quand même Firestore
          if (!response.ok) {
            console.warn('Impossible de supprimer le fichier de Cloudinary directement, mise à jour de la base de données uniquement');
          }
        } 
        // Si le fichier est sur Firebase Storage (a un path)
        else if (file.path) {
          try {
            // Supprimer le fichier du stockage Firebase
            const fileRef = ref(storage, file.path);
            await deleteObject(fileRef);
          } catch (storageError) {
            console.error('Erreur lors de la suppression du fichier dans Firebase Storage:', storageError);
            // Continuer quand même avec la mise à jour de Firestore
          }
        }
        
        // Mettre à jour le document de l'archive dans Firestore
        const archiveRef = doc(db, 'archives', archiveId);
        const archiveDoc = await getDoc(archiveRef);
        
        if (archiveDoc.exists()) {
          const archiveData = archiveDoc.data();
          const updatedFiles = [...archiveData.files];
          
          // Supprimer le fichier de la liste
          updatedFiles.splice(fileIndex, 1);
          
          // Mettre à jour le document
          await updateDoc(archiveRef, {
            files: updatedFiles,
            updatedAt: new Date()
          });
          
          // Si on est en train d'éditer cette archive, mettre à jour le formulaire
          if (currentArchive && currentArchive.id === archiveId) {
            setArchiveForm({
              ...archiveForm,
              files: updatedFiles
            });
          }
          
          // Rafraîchir les archives
          const user = auth.currentUser;
          if (user) {
            fetchArchives(user.uid);
          }
          
          setMessage('Fichier supprimé avec succès.');
          setTimeout(() => setMessage(''), 3000);
        } else {
          throw new Error("L'archive n'existe pas");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du fichier:", error);
        setMessage(`Erreur: ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  };
 

  const fetchStructureInfo = async () => {
    if (!currentUser) return;
    
    try {
      setLoading(true);
      const docRef = doc(db, "structures", currentUser.uid);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const structureData = docSnap.data();
        // S'assurer que les tableaux specialites et assurances existent
        if (!structureData.specialites) structureData.specialites = [];
        if (!structureData.assurances) structureData.assurances = [];
        
        setStructureInfo(structureData);
        setForm(structureData);
      } else {
        console.error("Aucune information trouvée pour cette structure");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des informations de la structure:", error);
      toast.error("Impossible de charger les informations de la structure");
    } finally {
      setLoading(false);
    }
  };

  
  // Gestion des formulaires médecin
  const handleMedecinChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...medecinForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setMedecinForm({ ...medecinForm, [name]: updatedArray });
    } else {
      setMedecinForm({ ...medecinForm, [name]: value });
    }
  };

  const handleDisponibiliteChange = (jour, field, value) => {
    setMedecinForm({
      ...medecinForm,
      disponibilites: {
        ...medecinForm.disponibilites,
        [jour]: {
          ...medecinForm.disponibilites[jour],
          [field]: field === 'actif' ? !medecinForm.disponibilites[jour].actif : value
        }
      }
    });
  };

  const resetMedecinForm = () => {
    setMedecinForm({
      nom: '',
      prenom: '',
      specialite: '',
      telephone: '',
      email: '',
      // Suppression du champ password
      disponibilites: {
        lundi: { actif: false, debut: '08:00', fin: '18:00' },
        mardi: { actif: false, debut: '08:00', fin: '18:00' },
        mercredi: { actif: false, debut: '08:00', fin: '18:00' },
        jeudi: { actif: false, debut: '08:00', fin: '18:00' },
        vendredi: { actif: false, debut: '08:00', fin: '18:00' },
        samedi: { actif: false, debut: '08:00', fin: '18:00' },
        dimanche: { actif: false, debut: '08:00', fin: '18:00' }
      },
      assurances: []
    });
    setCurrentMedecin(null);
  };

  const handleAddMedecin = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let medecinAuthId;
      let generatedPassword = '';
      
      if (!currentMedecin) {
        console.log("🔄 Création d'un nouveau médecin...");
        generatedPassword = generateRandomPassword(6);
        console.log("🔑 Mot de passe généré");
        
        try {
          // Utiliser la seconde instance d'authentification
          console.log("👤 Création du compte utilisateur...");
          const userCredential = await createUserWithEmailAndPassword(
            secondaryAuth, 
            medecinForm.email, 
            generatedPassword
          );
          medecinAuthId = userCredential.user.uid;
          console.log("✅ Compte utilisateur créé avec succès, UID:", medecinAuthId);
          
          // Déconnecter immédiatement l'utilisateur de la seconde instance
          await signOut(secondaryAuth);
          console.log("👋 Utilisateur déconnecté de l'authentification secondaire");
          
          // Préparer et envoyer le message de bienvenue
          console.log("📱 Préparation du message WhatsApp pour le médecin...");
          const welcomeMessage = `Bonjour Dr. ${medecinForm.prenom} ${medecinForm.nom},\n\n` +
            `Bienvenue sur notre plateforme de gestion médicale!\n\n` +
            `Voici vos informations de connexion:\n` +
            `Email: ${medecinForm.email}\n` +
            `Mot de passe: ${generatedPassword}\n\n` +
            `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;
          
          console.log("📞 Numéro de téléphone du médecin:", medecinForm.telephone);
          
          // Envoyer le message WhatsApp
          console.log("🚀 Envoi du message WhatsApp au médecin...");
          const messageResult = await sendWhatsAppMessage(medecinForm.telephone, welcomeMessage);
          
          if (messageResult.success) {
            console.log("✅ Message WhatsApp envoyé avec succès au médecin!");
            toast.success("Message de bienvenue envoyé au médecin par WhatsApp");
          } else {
            console.warn("⚠️ Impossible d'envoyer le message WhatsApp:", messageResult.error);
            toast.warning("Impossible d'envoyer le message WhatsApp au médecin. Vérifiez la configuration Maytapi.");
          }
        } catch (authError) {
          console.error("❌ Erreur lors de la création du compte:", authError);
          throw new Error(`Erreur d'authentification: ${authError.message}`);
        }
      } else {
        console.log("🔄 Mise à jour d'un médecin existant...");
        medecinAuthId = currentMedecin.id;
      }
      
      const disponibilitesAEnregistrer = [];
      Object.entries(medecinForm.disponibilites).forEach(([jour, valeur]) => {
        if (valeur.actif) {
          disponibilitesAEnregistrer.push({
            jour: jour.charAt(0).toUpperCase() + jour.slice(1),
            heureDebut: valeur.debut,
            heureFin: valeur.fin
          });
        }
      });
      
      const medecinData = {
        ...medecinForm,
        disponibilites: disponibilitesAEnregistrer,
        structureId: user.uid,
      };
      
      console.log("💾 Enregistrement des données du médecin...");
      
      if (currentMedecin) {
        await updateDoc(doc(db, 'medecins', currentMedecin.id), {
          ...medecinData,
          updatedAt: new Date()
        });
        console.log("✅ Médecin mis à jour avec succès");
        setMessage('Médecin mis à jour avec succès.');
      } else {
        await setDoc(doc(db, 'medecins', medecinAuthId), {
          ...medecinData,
          createdAt: new Date()
        });
        console.log("✅ Médecin ajouté avec succès");
        setMessage('Médecin ajouté avec succès.');
      }
      
      resetMedecinForm();
      setShowMedecinForm(false);
      fetchMedecins(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("❌ Erreur lors de l'ajout/modification du médecin:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  const handleEditMedecin = (medecin) => {
    setCurrentMedecin(medecin);
    
    // Conversion des disponibilités du format stocké vers le format du formulaire
    let disponibilitesFormattees = {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    };
    
    // Si le médecin a des disponibilités existantes, les convertir
    if (medecin.disponibilites && Array.isArray(medecin.disponibilites)) {
      medecin.disponibilites.forEach(dispo => {
        const jour = dispo.jour.toLowerCase();
        if (disponibilitesFormattees[jour]) {
          disponibilitesFormattees[jour] = {
            actif: true,
            debut: dispo.heureDebut || '08:00',
            fin: dispo.heureFin || '18:00'
          };
        }
      });
    } else if (medecin.disponibilites && typeof medecin.disponibilites === 'object') {
      // Si les disponibilités sont déjà au bon format
      disponibilitesFormattees = medecin.disponibilites;
    }
    
    setMedecinForm({
      nom: medecin.nom || '',
      prenom: medecin.prenom || '',
      specialite: medecin.specialite || '',
      telephone: medecin.telephone || '',
      email: medecin.email || '',
      password: '',  // Ne pas afficher le mot de passe existant
      disponibilites: disponibilitesFormattees,
      assurances: medecin.assurances || []
    });
    setShowMedecinForm(true);
  };

  const handleDeleteMedecin = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce médecin ?')) {
      try {
        await deleteDoc(doc(db, 'medecins', id));
        setMessage('Médecin supprimé avec succès.');
        const user = auth.currentUser;
        fetchMedecins(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires patient
  const handlePatientChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...patientForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setPatientForm({ ...patientForm, [name]: updatedArray });
    } else {
      setPatientForm({ ...patientForm, [name]: value });
    }
  };

  const resetPatientForm = () => {
    setPatientForm({
      nom: '',
      prenom: '',
      dateNaissance: '',
      email: '',
      telephone: '',
      assurances: [],
      diagnostics: '' // Réinitialisation du champ diagnostics
    });
    setCurrentPatient(null);
  };



  const fetchQuickRequests = async (structureId) => {
    try {
      const q = query(
        collection(db, 'quickAppointments'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const querySnapshot = await getDocs(q);
      const requests = [];
      querySnapshot.forEach((doc) => {
        requests.push({ id: doc.id, ...doc.data() });
      });
      setQuickRequests(requests);
      setQuickRequestsCount(requests.length);
    } catch (error) {
      console.error("Erreur lors de la récupération des demandes rapides:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, 'structures', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          fetchMedecins(user.uid);
          fetchPatients(user.uid);
          fetchRendezvous(user.uid);
          fetchArchives(user.uid);
          fetchPendingRequests(user.uid);
          fetchQuickRequests(user.uid); // Ajout de la récupération des demandes rapides
        }
      } else {
        navigate('/auth');
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Fonction pour accepter une demande de rendez-vous rapide
  const handleAcceptQuickRequest = async () => {
    try {
      if (!selectedQuickRequest || !selectedMedecinForQuick) {
        setMessage("Veuillez sélectionner un médecin pour ce rendez-vous.");
        return;
      }

      const user = auth.currentUser;
      const medecin = medecins.find(m => m.id === selectedMedecinForQuick);
      
      // Créer un nouveau rendez-vous à partir de la demande rapide
      const rdvData = {
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr. ${medecin.prenom} ${medecin.nom}`,
        medecinSpecialite: medecin.specialite,
        patientId: selectedQuickRequest.patientId || null,
        patientNom: `${selectedQuickRequest.prenom} ${selectedQuickRequest.nom}`,
        patientEmail: selectedQuickRequest.email,
        patientTelephone: selectedQuickRequest.telephone,
        date: selectedQuickRequest.dateFormatted,
        heure: selectedQuickRequest.heureRdv,
        duree: selectedQuickRequest.duree || "30",
        motif: selectedQuickRequest.motif || "Consultation",
        statut: "confirmé",
        structureId: user.uid,
        structureNom: selectedQuickRequest.structureNom || "",
        createdAt: new Date(),
        updatedAt: new Date(),
        source: "quick",
        verificationCode: selectedQuickRequest.verificationCode
      };

      // Ajouter le rendez-vous à la collection rendezvous
      const rdvRef = await addDoc(collection(db, 'rendezvous'), rdvData);
      
      // Mettre à jour le statut de la demande rapide
      await updateDoc(doc(db, 'quickAppointments', selectedQuickRequest.id), {
        status: "accepted",
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr. ${medecin.prenom} ${medecin.nom}`,
        rdvId: rdvRef.id,
        updatedAt: new Date()
      });

     

      setMessage("Demande de rendez-vous acceptée avec succès.");
      fetchQuickRequests(user.uid);
      fetchRendezvous(user.uid);
      setAssignMedecinModal(false);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  // Fonction pour refuser une demande de rendez-vous rapide
  const handleRejectQuickRequest = async (requestId) => {
    if (window.confirm('Êtes-vous sûr de vouloir refuser cette demande de rendez-vous ?')) {
      try {
        const user = auth.currentUser;
        
        // Mettre à jour le statut de la demande rapide
        await updateDoc(doc(db, 'quickAppointments', requestId), {
          status: "rejected",
          updatedAt: new Date()
        });

        setMessage("Demande de rendez-vous refusée.");
        fetchQuickRequests(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  // Ajouter un nouveau composant pour la section des demandes rapides
  const renderQuickRequestsSection = () => {
    return (
      <div className="card shadow-sm mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
            {quickRequestsCount > 0 && (
              <span className="badge bg-danger ms-2">{quickRequestsCount}</span>
            )}
          </h5>
          <Button 
            variant="primary" 
            size="sm"
            onClick={() => setShowQuickRequestsModal(true)}
          >
            Voir toutes les demandes
          </Button>
        </div>
        <div className="card-body">
          {quickRequests.length > 0 ? (
            <div className="quick-requests-preview">
             {quickRequests.slice(0, 3).map(request => (
  <div key={request.id} className="quick-request-item">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="mb-0">{request.prenom} {request.nom}</h6>
      <span className="badge bg-warning">En attente</span>
    </div>
    <div className="quick-request-details">
      <p><strong>Contact:</strong> {request.telephone}</p>
      {request.email && <p><strong>Email:</strong> {request.email}</p>}
      <p><strong>Date souhaitée:</strong> {request.dateFormatted}</p>
      <p><strong>Heure:</strong> {request.heureRdv}</p>
      {request.motif && <p><strong>Motif:</strong> {request.motif}</p>}
    </div>
    <div className="d-flex justify-content-end mt-2">
      <Button 
        variant="outline-danger" 
        size="sm" 
        className="me-2"
        onClick={() => handleRejectQuickRequest(request.id)}
      >
        <FontAwesomeIcon icon={faTimes} className="me-1" />
        Refuser
      </Button>
      <Button 
        variant="outline-success" 
        size="sm"
        onClick={() => {
          setSelectedQuickRequest(request);
          setAssignMedecinModal(true);
        }}
      >
        <FontAwesomeIcon icon={faCheck} className="me-1" />
        Accepter
      </Button>
    </div>
  </div>
))}

              {quickRequests.length > 3 && (
                <div className="text-center mt-3">
                  <Button 
                    variant="link" 
                    onClick={() => setShowQuickRequestsModal(true)}
                  >
                    Voir {quickRequests.length - 3} demandes supplémentaires
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <p className="text-center py-3 text-muted">Aucune demande de rendez-vous rapide en attente</p>
          )}
        </div>
      </div>
    );
  };













// Fonction pour afficher une notification plus détaillée
const showNotification = (message, type = 'success', duration = 5000) => {
  setMessage({
    text: message,
    type: type
  });
  
  setTimeout(() => setMessage(''), duration);
};









  const handleAddPatient = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let patientAuthId;
      let generatedPassword = '';
      
      if (!currentPatient) {
        console.log("🔄 Création d'un nouveau patient...");
        generatedPassword = generateRandomPassword(6);
        console.log("🔑 Mot de passe généré");
        
        try {
          // Utiliser la seconde instance d'authentification
          console.log("👤 Création du compte utilisateur pour le patient...");
          const userCredential = await createUserWithEmailAndPassword(
            secondaryAuth, 
            patientForm.email, 
            generatedPassword
          );
          patientAuthId = userCredential.user.uid;
          console.log("✅ Compte utilisateur créé avec succès pour le patient, UID:", patientAuthId);
          
          // Déconnecter immédiatement l'utilisateur de la seconde instance
          await signOut(secondaryAuth);
          console.log("👋 Utilisateur déconnecté de l'authentification secondaire");
          
          // Formater le numéro de téléphone pour WhatsApp
          let phoneNumber = patientForm.telephone;
          console.log("📞 Numéro de téléphone du patient:", phoneNumber);
          
          // Préparer et envoyer le message de bienvenue
          console.log("📱 Préparation du message WhatsApp pour le patient...");
          const welcomeMessage = `Bonjour ${patientForm.prenom} ${patientForm.nom},\n\n` +
            `Bienvenue sur notre plateforme de gestion médicale!\n\n` +
            `Voici vos informations de connexion:\n` +
            `Email: ${patientForm.email}\n` +
            `Mot de passe: ${generatedPassword}\n\n` +
            `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;
          
          // Envoyer le message WhatsApp
          console.log("🚀 Envoi du message WhatsApp au patient...");
          const messageResult = await sendWhatsAppMessage(phoneNumber, welcomeMessage);
          
          if (messageResult.success) {
            console.log("✅ Message WhatsApp envoyé avec succès au patient!");
            toast.success("Message de bienvenue envoyé au patient par WhatsApp");
          } else {
            console.warn("⚠️ Impossible d'envoyer le message WhatsApp au patient:", messageResult.error);
            toast.warning("Impossible d'envoyer le message WhatsApp au patient. Vérifiez la configuration Maytapi.");
          }
        } catch (authError) {
          console.error("❌ Erreur lors de la création du compte patient:", authError);
          throw new Error(`Erreur d'authentification: ${authError.message}`);
        }
      } else {
        console.log("🔄 Mise à jour d'un patient existant...");
        patientAuthId = currentPatient.id;
      }
      
      const patientData = {
        ...patientForm,
        structureId: user.uid,
      };
      
      console.log("💾 Enregistrement des données du patient...");
      
      if (currentPatient) {
        await updateDoc(doc(db, 'patients', currentPatient.id), {
          ...patientData,
          updatedAt: new Date()
        });
        console.log("✅ Patient mis à jour avec succès");
        setMessage('Patient mis à jour avec succès.');
      } else {
        await setDoc(doc(db, 'patients', patientAuthId), {
          ...patientData,
          createdAt: new Date()
        });
        console.log("✅ Patient ajouté avec succès");
        setMessage('Patient ajouté avec succès.');
      }
      
      resetPatientForm();
      setShowPatientForm(false);
      fetchPatients(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("❌ Erreur lors de l'ajout/modification du patient:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };
  
  

  const handleEditPatient = (patient) => {
    setCurrentPatient(patient);
    setPatientForm({
      nom: patient.nom || '',
      prenom: patient.prenom || '',
      dateNaissance: patient.dateNaissance || '',
      email: patient.email || '',
      password: '',  // Ne pas afficher le mot de passe existant
      telephone: patient.telephone || '',
      assurances: patient.assurances || [],
      diagnostics: patient.diagnostics || '' // Ajout du champ diagnostics
    });
    setShowPatientForm(true);
  };

  const handleDeletePatient = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce patient ?')) {
      try {
        await deleteDoc(doc(db, 'patients', id));
        setMessage('Patient supprimé avec succès.');
        const user = auth.currentUser;
        fetchPatients(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires rendez-vous
  const handleRdvChange = (e) => {
    const { name, value } = e.target;
    setRdvForm({ ...rdvForm, [name]: value });
  };

  const resetRdvForm = () => {
    setRdvForm({
      medecinId: '',
      patientId: '',
      date: new Date().toISOString().split('T')[0],
      heure: '08:00',
      duree: 15,
      motif: '',
      statut: 'confirmé'
    });
    setCurrentRendezvous(null);
  };

// Vérifier si l'heure de rendez-vous est disponible
const verifierDisponibilite = (medecinId, date, heure, duree, rdvIdAExclure = null) => {
  // Trouver le médecin
  const medecin = medecins.find(m => m.id === medecinId);
  if (!medecin) return false;
  
  // Vérifier le jour de la semaine
  const jourDate = new Date(date);
  const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const jourSemaine = joursMap[jourDate.getDay()];
  
  // Vérifier si le médecin travaille ce jour-là
  let disponibiliteJour = null;
  if (Array.isArray(medecin.disponibilites)) {
    disponibiliteJour = medecin.disponibilites.find(d => 
      d.jour.toLowerCase() === jourSemaine.toLowerCase()
    );
  } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
    disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
      heureDebut: medecin.disponibilites[jourSemaine].debut,
      heureFin: medecin.disponibilites[jourSemaine].fin
    } : null;
  }
  
  if (!disponibiliteJour) return false;
  
  // Vérifier si l'heure est dans la plage de disponibilité
  const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
  const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
  
  if (heure < heureDebut || heure > heureFin) return false;
  
  // Calculer l'heure de fin du rendez-vous
  const [heureH, heureM] = heure.split(':').map(Number);
  const heureFinRdv = new Date();
  heureFinRdv.setHours(heureH, heureM + parseInt(duree), 0, 0);
  const heureFinStr = `${heureFinRdv.getHours().toString().padStart(2, '0')}:${heureFinRdv.getMinutes().toString().padStart(2, '0')}`;
  
  if (heureFinStr > heureFin) return false;
  
  // Vérifier les chevauchements avec d'autres rendez-vous
  const rdvDuJour = rendezvous.filter(rdv => 
    rdv.medecinId === medecinId && 
    rdv.date === date && 
    rdv.statut !== 'annulé' &&
    rdv.id !== rdvIdAExclure
  );
  
  // Compter les rendez-vous à cette heure précise
  const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
  
  // Nombre maximum de rendez-vous simultanés autorisés
  const MAX_RDV_SIMULTANES = 3;
  
  // Si nous avons déjà atteint le nombre maximum de rendez-vous à cette heure
  if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
    return false;
  }
  
  return true;
};



  const handleAddRendezvous = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      
      // Vérifier la disponibilité
      const estDisponible = verifierDisponibilite(
        rdvForm.medecinId, 
        rdvForm.date, 
        rdvForm.heure, 
        rdvForm.duree,
        currentRendezvous?.id
      );
      
      if (!estDisponible) {
        setMessage("Erreur: Le médecin n'est pas disponible à cette heure ou il y a un conflit d'horaire.");
        return;
      }
      
      // Normaliser la date
      const dateObj = new Date(rdvForm.date);
      const normalizedDate = formatDateString(dateObj);
      
      const rdvData = {
        ...rdvForm,
        date: normalizedDate,
        structureId: user.uid,
      };
      
      // Récupérer les informations du médecin et du patient pour les stocker dans le rendez-vous
      const medecin = medecins.find(m => m.id === rdvForm.medecinId);
      const patient = patients.find(p => p.id === rdvForm.patientId);
      
      if (medecin) {
        rdvData.medecinNom = `${medecin.prenom} ${medecin.nom}`;
        rdvData.medecinSpecialite = medecin.specialite;
      }
      
      if (patient) {
        rdvData.patientNom = `${patient.prenom} ${patient.nom}`;
        rdvData.patientTelephone = patient.telephone;
        rdvData.patientEmail = patient.email;
      }
      
      let rdvId;
      
      if (currentRendezvous) {
        // Modification d'un rendez-vous existant
        rdvId = currentRendezvous.id;
        await updateDoc(doc(db, 'rendezvous', rdvId), {
          ...rdvData,
          updatedAt: new Date()
        });
        
        // Envoyer une notification de rendez-vous reprogrammé
        if (patient) {
          const notificationResult = await sendAppointmentNotification({
            ...rdvData,
            id: rdvId
          }, 'rescheduled');
          
          if (!notificationResult.success) {
            console.warn("Impossible d'envoyer la notification WhatsApp:", notificationResult.error);
          }
        }
        
        setMessage('Rendez-vous mis à jour avec succès.');
      } else {
        // Création d'un nouveau rendez-vous
        const docRef = await addDoc(collection(db, 'rendezvous'), {
          ...rdvData,
          createdAt: new Date()
        });
        rdvId = docRef.id;
        
        // Envoyer une notification de confirmation de rendez-vous
        if (patient) {
          const notificationResult = await sendAppointmentNotification({
            ...rdvData,
            id: rdvId
          }, 'confirmation');
          
          if (!notificationResult.success) {
            console.warn("Impossible d'envoyer la notification WhatsApp:", notificationResult.error);
          }
        }
        
        setMessage('Rendez-vous ajouté avec succès.');
      }
      
      resetRdvForm();
      setShowRendezvousForm(false);
      fetchRendezvous(user.uid);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  



  const handleEditRendezvous = (rdv) => {
    setCurrentRendezvous(rdv);
    setRdvForm({
      medecinId: rdv.medecinId || '',
      patientId: rdv.patientId || '',
      date: rdv.date || new Date().toISOString().split('T')[0],
      heure: rdv.heure || '08:00',
      duree: rdv.duree || '',
      motif: rdv.motif || '',
      statut: rdv.statut || 'confirmé'
    });
    setShowRendezvousForm(true);
  };

  const handleDeleteRendezvous = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
      try {
        await deleteDoc(doc(db, 'rendezvous', id));
        setMessage('Rendez-vous supprimé avec succès.');
        const user = auth.currentUser;
        fetchRendezvous(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  const handleChangeStatutRendezvous = async (id, nouveauStatut) => {
    try {
      // Récupérer les données du rendez-vous
      const rdvDoc = await getDoc(doc(db, 'rendezvous', id));
      if (!rdvDoc.exists()) {
        throw new Error("Le rendez-vous n'existe pas");
      }
      
      const rdvData = rdvDoc.data();
      
      await updateDoc(doc(db, 'rendezvous', id), {
        statut: nouveauStatut,
        updatedAt: new Date()
      });
      
      // Envoyer une notification selon le nouveau statut
      if (rdvData.patientTelephone) {
        let notificationType;
        
        if (nouveauStatut === 'annulé') {
          notificationType = 'cancellation';
        } else if (nouveauStatut === 'confirmé') {
          notificationType = 'confirmation';
        }
        
        if (notificationType) {
          const notificationResult = await sendAppointmentNotification({
            ...rdvData,
            id: id
          }, notificationType);
          
          if (!notificationResult.success) {
            console.warn("Impossible d'envoyer la notification WhatsApp:", notificationResult.error);
          }
        }
      }
      
      setMessage('Statut du rendez-vous mis à jour avec succès.');
      const user = auth.currentUser;
      fetchRendezvous(user.uid);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur lors de la mise à jour du statut: ${error.message}`);
    }
  };

  // Fonction pour envoyer des rappels de rendez-vous pour le lendemain
  const sendAppointmentReminders = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      
      if (!user) {
        throw new Error("Utilisateur non authentifié");
      }
      
      // Obtenir la date de demain
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowStr = formatDateString(tomorrow);
      
      // Récupérer tous les rendez-vous de demain qui sont confirmés
      const rdvsSnapshot = await getDocs(
        query(
          collection(db, 'rendezvous'),
          where("structureId", "==", user.uid),
          where("date", "==", tomorrowStr),
          where("statut", "==", "confirmé")
        )
      );
      
      let remindersSent = 0;
      let remindersTotal = rdvsSnapshot.size;
      
      // Si aucun rendez-vous demain
      if (remindersTotal === 0) {
        setMessage(`Aucun rendez-vous prévu pour demain.`);
        setTimeout(() => setMessage(''), 3000);
        return;
      }
      
      for (const doc of rdvsSnapshot.docs) {
        const rdv = doc.data();
        
        // Vérifier si le rendez-vous a un numéro de téléphone patient
        if (rdv.patientTelephone) {
          const result = await sendAppointmentNotification({
            ...rdv,
            id: doc.id
          }, 'reminder');
          
          if (result.success) {
            remindersSent++;
          }
        }
      }
      
      setMessage(`${remindersSent} rappels de rendez-vous envoyés sur ${remindersTotal} prévus pour demain.`);
      setTimeout(() => setMessage(''), 5000);
    } catch (error) {
      console.error("Erreur lors de l'envoi des rappels:", error);
      setMessage(`Erreur lors de l'envoi des rappels: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Filtrer les rendez-vous par date et médecin
  const rendezVousFiltres = rendezvous.filter(rdv => {
    let correspondDate = true;
    let correspondMedecin = true;
    
    if (filtreDate) {
      correspondDate = rdv.date === filtreDate;
    }
    
    if (filtreMedecin) {
      correspondMedecin = rdv.medecinId === filtreMedecin;
    }
    
    return correspondDate && correspondMedecin;
  });

  // Trier les rendez-vous par heure
  rendezVousFiltres.sort((a, b) => {
    if (a.date !== b.date) {
      return a.date.localeCompare(b.date);
    }
    return a.heure.localeCompare(b.heure);
  });

  // Fonction pour obtenir les créneaux disponibles
  const getCreneauxDisponibles = () => {
    if (!rdvForm.medecinId || !rdvForm.date) return [];
    
    const medecin = medecins.find(m => m.id === rdvForm.medecinId);
    if (!medecin) return [];
    
    // Déterminer le jour de la semaine
    const jourDate = new Date(rdvForm.date);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    // Obtenir les horaires du médecin pour ce jour
    let heureDebut = '08:00';
    let heureFin = '18:00';
    
    if (Array.isArray(medecin.disponibilites)) {
      const disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return []; // Le médecin ne travaille pas ce jour
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return []; // Le médecin ne travaille pas ce jour
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return []; // Pas de disponibilités pour ce jour
    }
    
    // Générer des créneaux de 15 minutes
    const creneaux = [];
    let heure = heureDebut;
    
    while (heure < heureFin) {
      const [h, m] = heure.split(':').map(Number);
      const heureFinCreneau = new Date();
      heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
      const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr <= heureFin) {
        // Vérifier si le créneau est disponible (pas de chevauchement avec d'autres RDV)
        const estDisponible = verifierDisponibilite(
          rdvForm.medecinId, 
          rdvForm.date, 
          heure, 
          rdvForm.duree,
          currentRendezvous?.id
        );
        
        if (estDisponible) {
          creneaux.push(heure);
        }
      }
      
      // Passer au créneau suivant (par tranches de 15 minutes)
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
    }
    
    return creneaux;
  };

  // Fonction pour basculer l'état du menu latéral
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Fonctions pour la vue calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };




 



  const handleDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      setShowDateModal(true);
    }
  };

  const handleMedecinClick = (medecinId) => {
    setSelectedMedecinId(medecinId);
    setShowMedecinRdvModal(true);
    setShowDateModal(false);
  };

  const handleRdvClick = (rdv) => {
    setSelectedRdv(rdv);
    setShowRdvDetailsModal(true);
  };

  const handleDragStart = (rdv) => {
    setDraggedRdv(rdv);
  };

  const handleDrop = async (targetRdv) => {
    if (!draggedRdv || draggedRdv.id === targetRdv.id) return;
    
    try {
      // Échanger les heures des rendez-vous
      const draggedHeure = draggedRdv.heure;
      const targetHeure = targetRdv.heure;
      
      await updateDoc(doc(db, 'rendezvous', draggedRdv.id), {
        heure: targetHeure,
        updatedAt: new Date()
      });
      
      await updateDoc(doc(db, 'rendezvous', targetRdv.id), {
        heure: draggedHeure,
        updatedAt: new Date()
      });
      
      setMessage('Rendez-vous échangés avec succès.');
      const user = auth.currentUser;
      fetchRendezvous(user.uid);
      
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur lors de l'échange: ${error.message}`);
    }
    
    setDraggedRdv(null);
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };
  const getMedecinsByDate = (date) => {
    const dateString = date.dateString || formatDateString(date.date);
    const rdvs = rendezvous.filter(rdv => rdv.date === dateString);
    const uniqueMedecinIds = [...new Set(rdvs.map(rdv => rdv.medecinId))];
    
    return uniqueMedecinIds.map(id => {
      const medecin = medecins.find(m => m.id === id);
      const medecinRdvs = rdvs.filter(rdv => rdv.medecinId === id);
      
      return {
        medecin: medecin,
        rdvCount: medecinRdvs.length
      };
    });
  };


const getMedecinRdvs = (medecinId, date) => {
  // Utiliser la date normalisée stockée dans l'objet day
  const dateString = date.dateString || formatDateString(date.date);
  
  return rendezvous
    .filter(rdv => rdv.medecinId === medecinId && rdv.date === dateString)
    .sort((a, b) => a.heure.localeCompare(b.heure));
};


// Fonction pour obtenir tous les créneaux avec leur statut (disponible, partiellement occupé ou complet)
const getCreneauxAvecStatut = () => {
  if (!rdvForm.medecinId || !rdvForm.date) return [];
  
  const medecin = medecins.find(m => m.id === rdvForm.medecinId);
  if (!medecin) return [];
  
  // Déterminer le jour de la semaine
  const jourDate = new Date(rdvForm.date);
  const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const jourSemaine = joursMap[jourDate.getDay()];
  
  // Obtenir les horaires du médecin pour ce jour
  let heureDebut = '08:00';
  let heureFin = '18:00';
  let disponibiliteJour = null;
  
  if (Array.isArray(medecin.disponibilites)) {
    disponibiliteJour = medecin.disponibilites.find(d => 
      d.jour.toLowerCase() === jourSemaine.toLowerCase()
    );
    
    if (disponibiliteJour) {
      heureDebut = disponibiliteJour.heureDebut;
      heureFin = disponibiliteJour.heureFin;
    } else {
      return []; // Le médecin ne travaille pas ce jour
    }
  } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
    if (!medecin.disponibilites[jourSemaine].actif) {
      return []; // Le médecin ne travaille pas ce jour
    }
    heureDebut = medecin.disponibilites[jourSemaine].debut;
    heureFin = medecin.disponibilites[jourSemaine].fin;
  } else {
    return []; // Pas de disponibilités pour ce jour
  }
  
  // Récupérer les rendez-vous existants pour ce médecin et cette date
  const rdvDuJour = rendezvous.filter(rdv => 
    rdv.medecinId === rdvForm.medecinId && 
    rdv.date === rdvForm.date && 
    rdv.statut !== 'annulé' &&
    rdv.id !== currentRendezvous?.id
  );
  
  // Générer tous les créneaux possibles (par tranches de 15 minutes)
  const tousLesCreneaux = [];
  let heure = heureDebut;
  
  // Nombre maximum de rendez-vous simultanés autorisés
  const MAX_RDV_SIMULTANES = 3;
  
  while (heure < heureFin) {
    const [h, m] = heure.split(':').map(Number);
    const heureFinCreneau = new Date();
    heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
    const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
    
    if (heureFinStr <= heureFin) {
      // Compter le nombre de rendez-vous à cette heure
      const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
      const nombreRdvAuCreneau = rdvAuCreneau.length;
      
      // Déterminer le statut du créneau
      let statut = 'disponible';
      if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
        statut = 'complet';
      } else if (nombreRdvAuCreneau > 0) {
        statut = 'partiel';
      }
      
      tousLesCreneaux.push({
        heure: heure,
        statut: statut,
        nombreRdv: nombreRdvAuCreneau,
        estDisponible: statut !== 'complet'
      });
    }
    
    // Passer au créneau suivant (par tranches de 15 minutes)
    const nextHeure = new Date();
    nextHeure.setHours(h, m + 15, 0, 0);
    heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
  }
  
  return tousLesCreneaux;
};



  const handleMobileTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setMobileDetailView(null);
  };

  const handleMobileDetailView = (type, item) => {
    setMobileDetailView({ type, item });
  };

  const handleBackToList = () => {
    setMobileDetailView(null);
  };

  const handleMobileSearch = (e) => {
    setMobileSearchQuery(e.target.value);
  };

  const filteredMedecins = mobileSearchActive && mobileSearchQuery 
    ? medecins.filter(m => 
        `${m.nom} ${m.prenom}`.toLowerCase().includes(mobileSearchQuery.toLowerCase()) ||
        m.specialite.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : medecins;

  const filteredPatients = mobileSearchActive && mobileSearchQuery 
    ? patients.filter(p => 
        `${p.nom} ${p.prenom}`.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : patients;

  const filteredRendezvous = mobileSearchActive && mobileSearchQuery 
    ? rendezvous.filter(r => 
        r.patientNom?.toLowerCase().includes(mobileSearchQuery.toLowerCase()) ||
        r.medecinNom?.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : rendezvous;

    
    // Fonction pour accepter une demande de rendez-vous
const handleAccepterDemandeRapide = async (demande) => {
  if (!currentUser) return;

  try {
    setLoading(true);
    
    // Chercher si le patient existe déjà
    const patientQuery = query(
      collection(db, 'patients'),
      where("structureId", "==", demande.structureId),
      where("telephone", "==", demande.telephone)
    );
    const patientSnapshot = await getDocs(patientQuery);
    
    let patientId = null;
    
    // Si le patient n'existe pas encore, le créer
    if (patientSnapshot.empty) {
      const patientData = {
        nom: demande.nom,
        prenom: demande.prenom,
        dateNaissance: demande.dateNaissance || '',
        email: demande.email || '',
        telephone: demande.telephone,
        structureId: demande.structureId,
        createdAt: new Date(),
        assurances: [],
        diagnostics: '' // Ajout du champ diagnostics
      };
      
      const docRef = await addDoc(collection(db, 'patients'), patientData);
      patientId = docRef.id;
    } else {
      patientId = patientSnapshot.docs[0].id;
    }
    
    // Mettre à jour le rendez-vous
    await updateDoc(doc(db, 'rendezvous', demande.id), {
      statut: 'confirmé',
      patientId: patientId
    });
    

    // Rafraîchir les données
    fetchDemandesRapides();
    fetchRendezvous(currentUser.uid);
    
    toast.success("La demande a été acceptée avec succès !");
  } catch (error) {
    console.error("Erreur lors de l'acceptation de la demande:", error);
    toast.error(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour récupérer les demandes rapides
const fetchDemandesRapides = async () => {
  if (!currentUser) return;

  try {
    setLoading(true);
    const q = query(
      collection(db, 'rendezvous'),
      where("structureId", "==", currentUser.uid),
      where("statut", "==", "confirmé"),
      where("source", "==", "quick")
    );
    
    const querySnapshot = await getDocs(q);
    const demandes = [];
    
    querySnapshot.forEach((doc) => {
      demandes.push({ id: doc.id, ...doc.data() });
    });
    
    setDemandesRapides(demandes);
  } catch (error) {
    console.error("Erreur lors de la récupération des demandes rapides:", error);
    toast.error("Impossible de charger les demandes rapides");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    setCurrentUser(user);
  });
  
  // Nettoyer l'abonnement lors du démontage du composant
  return () => unsubscribe();
}, []);

// Modifier useEffect pour charger les demandes rapides
useEffect(() => {
  if (currentUser) {
    fetchStructureInfo();
    fetchRendezvous(currentUser.uid);
    fetchDemandesRapides();
    fetchPatients(currentUser.uid);
    fetchMedecins(currentUser.uid);
  }
}, [currentUser]);


// Fonction pour refuser une demande rapide
const handleRefuserDemandeRapide = async (demandeId) => {
  try {
    setLoading(true);
    
    // Mettre à jour le statut du rendez-vous à "refusé"
    await updateDoc(doc(db, 'rendezvous', demandeId), {
      statut: 'refusé'
    });
    
    // Rafraîchir les données
    fetchDemandesRapides();
    
    toast.success("La demande rapide a été refusée.");
  } catch (error) {
    console.error("Erreur lors du refus de la demande rapide:", error);
    toast.error(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

  // Composant pour afficher les demandes rapides
  const RenderDemandesRapides = () => {
    const [activeTab, setActiveTabRdv] = useState('tous'); // 'tous' pour voir toutes les demandes
    const [demandesRapides, setDemandesRapides] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fonction pour récupérer toutes les demandes rapides
    const fetchDemandesRapides = async () => {
      if (!currentUser) return;

      try {
        setLoading(true);
        const q = query(
          collection(db, 'rendezvous'),
          where("structureId", "==", currentUser.uid),
          where("source", "==", "quick"),
          orderBy("createdAt", "desc") // Pour avoir les plus récentes en premier
        );
        
        const querySnapshot = await getDocs(q);
        const demandes = [];
        
        querySnapshot.forEach((doc) => {
          demandes.push({ id: doc.id, ...doc.data() });
        });
        
        setDemandesRapides(demandes);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes rapides:", error);
        toast.error("Impossible de charger les demandes rapides");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchDemandesRapides();
    }, [currentUser]);

    return (
      <div className="demandes-rapides-section">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4>
            <FontAwesomeIcon icon={faBolt} className="me-2 text-warning" />
            Demandes de rendez-vous rapides
          </h4>
          <button 
            className="btn btn-sm btn-outline-primary" 
            onClick={fetchDemandesRapides}
            disabled={loading}
          >
            {loading ? 
              <FontAwesomeIcon icon={faSpinner} spin /> : 
              <FontAwesomeIcon icon={faSync} />} Actualiser
          </button>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
            <p className="mt-2">Chargement des demandes...</p>
          </div>
        ) : demandesRapides.length === 0 ? (
          <div className="alert alert-info">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            Aucune demande de rendez-vous rapide.
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>Date de demande</th>
                  <th>Patient</th>
                  <th>Contact</th>
                  <th>Date souhaitée</th>
                  <th>Heure</th>
                  <th>Motif</th>
                  <th>Code de vérification</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
              {demandesRapides.map((demande) => {
  console.log('Données de la demande:', demande);
  console.log('Date formatée:', demande.dateFormatted || demande.date);
  console.log('Heure du RDV:', demande.heureRdv || demande.heure);
  console.log('Informations patient:', {
    nom: demande.patientNom || demande.nom,  // Ajout de patientNom comme alternative
    prenom: demande.patientPrenom || demande.prenom,  // Ajout de patientPrenom comme alternative
    telephone: demande.patientTelephone || demande.telephone,  // Ajout de patientTelephone comme alternative
    email: demande.patientEmail || demande.email  // Utilisation de patientEmail qui est présent dans les données
  });
  console.log('Statut de la demande:', demande.statut);
  console.log('Code de vérification:', demande.verificationCode);
  
  return (
    <tr key={demande.id}>
      <td>{new Date(demande.createdAt?.toDate()).toLocaleString()}</td>
      <td>
        <div className="fw-bold">
          {(demande.patientPrenom || demande.prenom)} {(demande.patientNom || demande.nom)}
        </div>
        <div className="small text-muted">
          {demande.dateNaissance && `Né(e) le ${formatDate(demande.dateNaissance)}`}
        </div>
      </td>
      <td>
        <div>{demande.patientTelephone || demande.telephone}</div>
        <div className="small text-muted">{demande.patientEmail || demande.email}</div>
      </td>
      <td>{formatDate(demande.dateRdv || demande.date)}</td>
      <td>{demande.heureRdv || demande.heure}</td>
      <td>
        <span 
          className="text-truncate d-inline-block" 
          style={{maxWidth: "150px"}} 
          title={demande.motif}
        >
          {demande.motif || <span className="text-muted">Non spécifié</span>}
        </span>
      </td>
      <td>
        <span className="badge bg-info">
          {demande.verificationCode}
        </span>
      </td>
      <td>
        <span className={`badge ${
          demande.statut === 'confirmé' ? 'bg-success' : 
          demande.statut === 'en attente' ? 'bg-warning' :
          demande.statut === 'annulé' ? 'bg-danger' : 'bg-secondary'
        }`}>
          {demande.statut}
        </span>
      </td>
    </tr>
  );
})}

              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };


// Fin des composants pour les demandes rapides




useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const docRef = doc(db, 'structures', user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setStructureData(docSnap.data());
        // Autres appels pour récupérer les données
      } else {
        navigate('/auth');
      }
    } else {
      navigate('/auth');
    }
  });
  return () => unsubscribe();
}, [auth, navigate]);



  if (!structureData) return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement...</span>
      </div>
    </div>
  );

  if(isMobile){
return (
  <div className="dashboard-container mobile">
   {/* Barre de navigation mobile */}
<nav className="mobile-nav">
  <div className="mobile-header">
    <div className="header-actions">
      <button className="menu-toggle" onClick={toggleSidebar}>
        <FontAwesomeIcon icon={sidebarCollapsed ? faBars : faTimes} />
      </button>
      {/* Boutons d'action spécifiques à chaque onglet */}
      <div className="action-buttons-mobile">
          {activeTab === 'medecins' && (
            <button 
              className="btn-floating" 
              onClick={() => {
                resetMedecinForm();
                setShowMedecinForm(!showMedecinForm);
              }}
            >
              <FontAwesomeIcon icon={showMedecinForm ? faTimes : faPlus} />
            </button>
          )}
          
          {activeTab === 'patients' && (
            <button 
              className="btn-floating" 
              onClick={() => {
                resetPatientForm();
                setShowPatientForm(!showPatientForm);
              }}
            >
              <FontAwesomeIcon icon={showPatientForm ? faTimes : faPlus} />
            </button>
          )}
          
          {activeTab === 'rendezvous' && (
            <button 
              className="btn-floating" 
              onClick={() => {
                resetRdvForm();
                setShowRendezvousForm(!showRendezvousForm);
              }}
            >
              <FontAwesomeIcon icon={showRendezvousForm ? faTimes : faPlus} />
            </button>
          )}
          
          {activeTab === 'archives' && (
            <button 
              className="btn-floating" 
              onClick={() => {
                resetArchiveForm();
                setShowArchiveForm(!showArchiveForm);
              }}
            >
              <FontAwesomeIcon icon={showArchiveForm ? faTimes : faPlus} />
            </button>
          )}
        </div>
    </div>
    
    <h3>{structureData.nom}</h3>
  </div>
</nav>


    {/* Menu latéral en version mobile (affichage en overlay) */}
    <div className={`sidebar-mobile ${sidebarCollapsed ? 'hidden' : 'visible'}`}>
      <div className="sidebar-menu-mobile">
        <ul>
          <li className={activeTab === 'info' ? 'active' : ''} onClick={() => {setActiveTab('info'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faHome} />
            <span>Informations</span>
          </li>
          <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => {setActiveTab('affiliations'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faLink} />
            <span>Affiliations</span>
            {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0) > 0 && (
              <span className="badge bg-danger">
                {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0)}
              </span>
            )}
          </li>
          <li className={activeTab === 'medecins' ? 'active' : ''} onClick={() => {setActiveTab('medecins'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faUserMd} />
            <span>Médecins</span>
            <span className="badge bg-info">{medecins.length}</span>
          </li>
          <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => {setActiveTab('patients'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faUser} />
            <span>Patients</span>
            <span className="badge bg-info">{patients.length}</span>
          </li>
          <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => {setActiveTab('rendezvous'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Rendez-vous</span>
            <div className="badge-container">
              <span className="badge bg-info">{rendezvous.length}</span>
              {quickRequestsCount > 0 && (
                <span className="badge bg-danger quick-badge">{quickRequestsCount}</span>
              )}
            </div>
          </li>
          <li className={activeTab === 'archives' ? 'active' : ''} onClick={() => {setActiveTab('archives'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faArchive} />
            <span>Archives</span>
            <span className="badge bg-info">{archives.length}</span>
          </li>
          <li className={activeTab === 'demandesRapides' ? 'active' : ''} onClick={() => {setActiveTab('demandesRapides'); toggleSidebar();}}>
            <FontAwesomeIcon icon={faBolt} />
            <span>Rendez-vous rapides</span>
            <div className="badge-container">
              <span className="badge bg-warning ms-2">{demandesRapides.length}</span>
            </div>
          </li>
          <li onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Déconnexion</span>
          </li>
        </ul>
      </div>
    </div>

    {/* Contenu principal */}
    <div className="main-content-mobile">
      {/* En-tête avec le titre de la section active */}
      <div className="content-header-mobile">
        <h2>
          {activeTab === 'info' && 'Informations'}
          {activeTab === 'affiliations' && 'Affiliations'}
          {activeTab === 'medecins' && 'Médecins'}
          {activeTab === 'patients' && 'Patients'}
          {activeTab === 'rendezvous' && 'Rendez-vous'}
          {activeTab === 'archives' && 'Archives'}
          {activeTab === 'demandesRapides' && 'RDV rapides'}
        </h2>
        
       
      </div>

      {/* Affichage des messages de notification */}
      {message && (
        <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
          {message}
          <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
        </div>
      )}

      {/* Contenu des différents onglets */}
      <div className="content-body-mobile">
        {/* Onglet Informations */}
        {activeTab === 'info' && (
  <div className="card shadow-sm">
    <div className="card-body">
      <div className="form-mobile">
        {Object.keys(form).map((key) => {
          if (key === 'createdAt' || key === 'updatedAt') {
            return null;
          }
          
          // Traitement spécial pour les spécialités
          if (key === 'specialites') {
            return (
              <div className="form-group-mobile" key={key}>
                <label className="form-label">Spécialités</label>
                <div className="badge-container">
                  {form.specialites && form.specialites.length > 0 ? (
                    form.specialites.map(specialite => (
                      <span key={specialite} className="badge bg-primary m-1">{specialite}</span>
                    ))
                  ) : (
                    <span className="text-muted">Aucune spécialité sélectionnée</span>
                  )}
                </div>
                <div className="specialty-checkboxes mt-2">
                  {specialites.map(specialite => (
                    <div key={specialite} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`specialite-${specialite}`}
                        value={specialite}
                        checked={form.specialites?.includes(specialite) || false}
                        onChange={(e) => {
                          const { checked, value } = e.target;
                          let updatedSpecialites = [...(form.specialites || [])];
                          if (checked) {
                            updatedSpecialites.push(value);
                          } else {
                            updatedSpecialites = updatedSpecialites.filter(s => s !== value);
                          }
                          setForm({ ...form, specialites: updatedSpecialites });
                        }}
                      />
                      <label className="form-check-label" htmlFor={`specialite-${specialite}`}>
                        {specialite}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          
          // Traitement spécial pour les assurances
          if (key === 'assurances') {
            return (
              <div className="form-group-mobile" key={key}>
                <label className="form-label">Assurances acceptées</label>
                <div className="badge-container">
                  {form.assurances && form.assurances.length > 0 ? (
                    form.assurances.map(assurance => (
                      <span key={assurance} className="badge bg-success m-1">{assurance}</span>
                    ))
                  ) : (
                    <span className="text-muted">Aucune assurance sélectionnée</span>
                  )}
                </div>
                <div className="insurance-checkboxes mt-2">
                  {assurancesList.map(assurance => (
                    <div key={assurance} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`assurance-${assurance}`}
                        value={assurance}
                        checked={form.assurances?.includes(assurance) || false}
                        onChange={(e) => {
                          const { checked, value } = e.target;
                          let updatedAssurances = [...(form.assurances || [])];
                          if (checked) {
                            updatedAssurances.push(value);
                          } else {
                            updatedAssurances = updatedAssurances.filter(a => a !== value);
                          }
                          setForm({ ...form, assurances: updatedAssurances });
                        }}
                      />
                      <label className="form-check-label" htmlFor={`assurance-${assurance}`}>
                        {assurance}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          
          // Pour les autres champs, conserver le comportement actuel
          return (
            <div className="form-group-mobile" key={key}>
              <label className="form-label">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
              <input
                name={key}
                value={form[key] || ''}
                onChange={handleChange}
                className="form-control"
                placeholder={key}
              />
            </div>
          );
        })}
      </div>
      <div className="action-container-mobile">
        <button onClick={handleUpdate} className="btn btn-primary btn-block">
          <FontAwesomeIcon icon={faCheck} className="me-2" />
          Mettre à jour
        </button>
      </div>
    </div>
  </div>
)}

        {/* Onglet Affiliations */}
        {activeTab === 'affiliations' && (
          <div className="card shadow-sm">
            <div className="card-body">
              <AffiliationRequestsManager onRequestProcessed={fetchPendingRequests} />
            </div>
          </div>
        )}

        {/* Onglet Médecins - Affichage en mode carte */}
        {activeTab === 'medecins' && (
          <div>
            {showMedecinForm && (
              <div className="form-card-mobile">
                <h5>{currentMedecin ? 'Modifier le médecin' : 'Ajouter un médecin'}</h5>
                <form onSubmit={handleAddMedecin}>
                  <div className="form-group-mobile">
                    <label className="form-label">Nom</label>
                    <input
                      type="text"
                      name="nom"
                      className="form-control"
                      value={medecinForm.nom}
                      onChange={handleMedecinChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Prénom</label>
                    <input
                      type="text"
                      name="prenom"
                      className="form-control"
                      value={medecinForm.prenom}
                      onChange={handleMedecinChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Spécialité</label>
                    <select
                      name="specialite"
                      className="form-select"
                      value={medecinForm.specialite}
                      onChange={handleMedecinChange}
                      required
                    >
                      <option value="">Sélectionner une spécialité</option>
                      {specialites.map((spec) => (
                        <option key={spec} value={spec}>{spec}</option>
                      ))}
                    </select>
                    {medecinForm.specialite === 'Autre' && (
                      <input
                        type="text"
                        name="specialiteAutre"
                        className="form-control mt-2"
                        placeholder="Précisez la spécialité"
                        value={medecinForm.specialiteAutre || ''}
                        onChange={handleMedecinChange}
                      />
                    )}
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Téléphone</label>
                    <input
                      type="tel"
                      name="telephone"
                      className="form-control"
                      value={medecinForm.telephone}
                      onChange={handleMedecinChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={medecinForm.email}
                      onChange={handleMedecinChange}
                      required
                    />
                  </div>

                  <div className="form-group-mobile">
                    <label className="form-label">Disponibilités</label>
                    <div className="accordion" id="disponibilitesAccordion">
                      {joursSemaine.map((jour) => (
                        <div className="accordion-item" key={jour}>
                          <h2 className="accordion-header">
                            <button 
                              className="accordion-button collapsed" 
                              type="button" 
                              data-bs-toggle="collapse" 
                              data-bs-target={`#collapse${jour}`}
                            >
                              {jour.charAt(0).toUpperCase() + jour.slice(1)}
                              {medecinForm.disponibilites[jour].actif && 
                                <span className="badge bg-success ms-2">Actif</span>
                              }
                            </button>
                          </h2>
                          <div 
                            id={`collapse${jour}`} 
                            className="accordion-collapse collapse"
                            data-bs-parent="#disponibilitesAccordion"
                          >
                            <div className="accordion-body">
                              <div className="form-check form-switch mb-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`disponible-${jour}`}
                                  checked={medecinForm.disponibilites[jour].actif}
                                  onChange={() => handleDisponibiliteChange(jour, 'actif')}
                                />
                                <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                                  {medecinForm.disponibilites[jour].actif ? 'Disponible' : 'Non disponible'}
                                </label>
                              </div>
                              {medecinForm.disponibilites[jour].actif && (
                                <div className="row">
                                  <div className="col-6">
                                    <label className="form-label">Début</label>
                                    <input
                                      type="time"
                                      className="form-control"
                                      value={medecinForm.disponibilites[jour].debut}
                                      onChange={(e) => handleDisponibiliteChange(jour, 'debut', e.target.value)}
                                    />
                                  </div>
                                  <div className="col-6">
                                    <label className="form-label">Fin</label>
                                    <input
                                      type="time"
                                      className="form-control"
                                      value={medecinForm.disponibilites[jour].fin}
                                      onChange={(e) => handleDisponibiliteChange(jour, 'fin', e.target.value)}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="form-group-mobile">
                    <label className="form-label">Assurances acceptées</label>
                    <div className="assurances-grid">
                      {assurancesList.map((assurance) => (
                        <div className="form-check" key={assurance}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`assurance-medecin-${assurance}`}
                            name="assurances"
                            value={assurance}
                            checked={medecinForm.assurances.includes(assurance)}
                            onChange={handleMedecinChange}
                          />
                          <label className="form-check-label" htmlFor={`assurance-medecin-${assurance}`}>
                            {assurance}
                          </label>
                        </div>
                      ))}
                    </div>
                    {medecinForm.assurances.includes('Autre') && (
                      <input
                        type="text"
                        name="assuranceAutre"
                        className="form-control mt-2"
                        placeholder="Précisez l'assurance"
                        value={medecinForm.assuranceAutre || ''}
                        onChange={handleMedecinChange}
                      />
                    )}
                  </div>

                  <div className="action-container-mobile">
                    <button type="button" className="btn btn-secondary btn-block mb-2" onClick={() => {
                      resetMedecinForm();
                      setShowMedecinForm(false);
                    }}>
                      <FontAwesomeIcon icon={faTimes} className="me-2" />
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary btn-block">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      {currentMedecin ? 'Mettre à jour' : 'Ajouter'}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Liste des médecins en mode carte */}
            <div className="cards-grid-mobile">
              {medecins.length > 0 ? (
                medecins.map((medecin) => (
                  <div className="card-mobile" key={medecin.id}>
                    <div className="card-header-mobile">
                      <h5>Dr. {medecin.prenom} {medecin.nom}</h5>
                      <span className="badge bg-info">{medecin.specialite}</span>
                    </div>
                    <div className="card-content-mobile">
                      <p>
                        <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                        {medecin.telephone}
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                        {medecin.email}
                      </p>
                      <div className="mt-2">
                        <h6>Disponibilités:</h6>
                        <div className="tags-container">
                          {Object.entries(medecin.disponibilites || {}).map(([jour, dispo]) => (
                            dispo.actif && (
                              <span key={jour} className="tag">
                                {jour.charAt(0).toUpperCase() + jour.slice(1).substring(0, 2)}: {dispo.debut.substring(0, 5)}-{dispo.fin.substring(0, 5)}
                              </span>
                            )
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-actions-mobile">
                      <button
                        className="btn-icon"
                        onClick={() => handleEditMedecin(medecin)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="btn-icon danger"
                        onClick={() => handleDeleteMedecin(medecin.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state">
                  <p>Aucun médecin n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetMedecinForm();
                      setShowMedecinForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Ajouter un médecin
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Patients - Affichage en mode carte */}
        {activeTab === 'patients' && (
          <div>
            {showPatientForm && (
              <div className="form-card-mobile">
                <h5>{currentPatient ? 'Modifier le patient' : 'Ajouter un patient'}</h5>
                <form onSubmit={handleAddPatient}>
                  <div className="form-group-mobile">
                    <label className="form-label">Nom</label>
                    <input
                      type="text"
                      name="nom"
                      className="form-control"
                      value={patientForm.nom}
                      onChange={handlePatientChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Prénom</label>
                    <input
                      type="text"
                      name="prenom"
                      className="form-control"
                      value={patientForm.prenom}
                      onChange={handlePatientChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Date de naissance</label>
                    <input
                      type="date"
                      name="dateNaissance"
                      className="form-control"
                      value={patientForm.dateNaissance}
                      onChange={handlePatientChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Téléphone</label>
                    <input
                      type="tel"
                      name="telephone"
                      className="form-control"
                      value={patientForm.telephone}
                      onChange={handlePatientChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={patientForm.email}
                      onChange={handlePatientChange}
                      required
                    />
                  </div>

                  <div className="form-group-mobile">
                    <label className="form-label">Assurances</label>
                    <div className="assurances-grid">
                      {assurancesList.map((assurance) => (
                        <div className="form-check" key={assurance}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`assurance-patient-${assurance}`}
                            name="assurances"
                            value={assurance}
                            checked={patientForm.assurances.includes(assurance)}
                            onChange={handlePatientChange}
                          />
                          <label className="form-check-label" htmlFor={`assurance-patient-${assurance}`}>
                            {assurance}
                          </label>
                        </div>
                      ))}
                    </div>
                    {patientForm.assurances.includes('Autre') && (
                      <input
                        type="text"
                        name="assuranceAutre"
                        className="form-control mt-2"
                        placeholder="Précisez l'assurance"
                        value={patientForm.assuranceAutre || ''}
                        onChange={handlePatientChange}
                      />
                    )}
                  </div>

                  <div className="form-group-mobile">
                    <label className="form-label">Diagnostics</label>
                    <textarea
                      name="diagnostics"
                      className="form-control"
                      value={patientForm.diagnostics}
                      onChange={handlePatientChange}
                      rows="3"
                      placeholder="Entrez les diagnostics du patient"
                    />
                  </div>

                  <div className="action-container-mobile">
                    <button type="button" className="btn btn-secondary btn-block mb-2" onClick={() => {
                      resetPatientForm();
                      setShowPatientForm(false);
                    }}>
                      <FontAwesomeIcon icon={faTimes} className="me-2" />
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary btn-block">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      {currentPatient ? 'Mettre à jour' : 'Ajouter'}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Liste des patients en mode carte */}
            <div className="cards-grid-mobile">
              {patients.length > 0 ? (
                patients.map((patient) => (
                  <div className="card-mobile" key={patient.id}>
                    <div className="card-header-mobile">
                      <h5>{patient.prenom} {patient.nom}</h5>
                      <span className="badge bg-secondary">
                        {new Date().getFullYear() - new Date(patient.dateNaissance).getFullYear()} ans
                      </span>
                    </div>
                    <div className="card-content-mobile">
                      <p>
                        <small className="text-muted">Né(e) le {new Date(patient.dateNaissance).toLocaleDateString()}</small>
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                        {patient.telephone}
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                        {patient.email}
                      </p>
                      <div className="mt-2">
                        <h6>Assurances:</h6>
                        <div className="tags-container">
                          {patient.assurances && patient.assurances.map((assurance, index) => (
                            <span key={index} className="tag">
                              {assurance}
                            </span>
                          ))}
                        </div>
                      </div>
                      {patient.diagnostics && (
                        <div className="mt-2">
                          <h6>Diagnostics:</h6>
                          <p className="text-muted">{patient.diagnostics}</p>
                        </div>
                      )}
                    </div>
                    <div className="card-actions-mobile">
                      <button
                        className="btn-icon"
                        onClick={() => handleEditPatient(patient)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="btn-icon danger"
                        onClick={() => handleDeletePatient(patient.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state">
                  <p>Aucun patient n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetPatientForm();
                      setShowPatientForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Ajouter un patient
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Rendez-vous - Vue calendrier simplifiée */}
        {activeTab === 'rendezvous' && (
          <div>
            {showRendezvousForm && (
              <div className="form-card-mobile">
                <h5>{currentRendezvous ? 'Modifier le rendez-vous' : 'Ajouter un rendez-vous'}</h5>
                <form onSubmit={handleAddRendezvous}>
                  <div className="form-group-mobile">
                    <label className="form-label">Médecin</label>
                    <select
                      name="medecinId"
                      className="form-select"
                      value={rdvForm.medecinId}
                      onChange={handleRdvChange}
                      required
                    >
                      <option value="">Sélectionner un médecin</option>
                      {medecins.map((medecin) => (
                        <option key={medecin.id} value={medecin.id}>
                          Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Patient</label>
                    <select
                      name="patientId"
                      className="form-select"
                      value={rdvForm.patientId}
                      onChange={handleRdvChange}
                      required
                    >
                      <option value="">Sélectionner un patient</option>
                      {patients.map((patient) => (
                        <option key={patient.id} value={patient.id}>
                          {patient.prenom} {patient.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      name="date"
                      className="form-control"
                      value={rdvForm.date}
                      onChange={handleRdvChange}
                      required
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Heure</label>
                    <div className="time-slots-mobile">
                      {rdvForm.medecinId && rdvForm.date ? (
                        getCreneauxAvecStatut().map((creneau) => (
                          <div 
                            key={creneau.heure}
                            className={`time-slot ${creneau.statut} ${rdvForm.heure === creneau.heure ? 'selected' : ''}`}
                            onClick={() => {
                              if (creneau.statut !== 'complet') {
                                setRdvForm({...rdvForm, heure: creneau.heure});
                              }
                            }}
                          >
                            {creneau.heure}
                            {creneau.statut === 'partiel' && (
                              <div className="slot-info">
                                {creneau.nombreRdv}/{3}
                              </div>
                            )}
                            {creneau.statut === 'complet' && (
                              <div className="slot-info">Complet</div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="alert alert-info">
                          Veuillez sélectionner un médecin et une date
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Motif</label>
                    <textarea
                      name="motif"
                      className="form-control"
                      value={rdvForm.motif}
                      onChange={handleRdvChange}
                      rows="3"
                    />
                  </div>
                  <div className="form-group-mobile">
                    <label className="form-label">Statut
                    </label>
                    <select
                      name="statut"
                      className="form-select"
                      value={rdvForm.statut}
                      onChange={handleRdvChange}
                      required
                    >
                      {statutsRdv.map((statut) => (
                        <option key={statut} value={statut}>
                          {statut.charAt(0).toUpperCase() + statut.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="action-container-mobile">
                    <button type="button" className="btn btn-secondary btn-block mb-2" onClick={() => {
                      resetRdvForm();
                      setShowRendezvousForm(false);
                    }}>
                      <FontAwesomeIcon icon={faTimes} className="me-2" />
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary btn-block">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      {currentRendezvous ? 'Mettre à jour' : 'Ajouter'}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Vue calendrier simplifiée */}
            <div className="calendar-mobile">
              <div className="calendar-header-mobile">
                <button className="btn-icon" onClick={handlePrevMonth}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h5>
                  {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                </h5>
                <button className="btn-icon" onClick={handleNextMonth}>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
              <div className="calendar-days-mobile">
                {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
                  <div key={index} className="calendar-day-header">
                    {day}
                  </div>
                ))}
              </div>
              <div className="calendar-grid-mobile">
                {getMonthData().map((day, index) => (
                  <div 
                    key={index} 
                    className={`calendar-day-mobile ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                    onClick={() => handleDateClick(day)}
                  >
                    <div className="day-number">{day.date.getDate()}</div>
                    {day.hasEvents && (
                      <div className="event-dot"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            
            {/* Liste des rendez-vous du jour */}
            <div className="day-appointments-mobile">
              <h6>Rendez-vous à venir</h6>
              <div className="appointments-list-mobile">
                {rendezvous
                  .filter(rdv => new Date(rdv.date) >= new Date().setHours(0,0,0,0))
                  .sort((a, b) => new Date(a.date + 'T' + a.heure) - new Date(b.date + 'T' + b.heure))
                  .slice(0, 5)
                  .map(rdv => {
                    const patient = patients.find(p => p.id === rdv.patientId);
                    const medecin = medecins.find(m => m.id === rdv.medecinId);
                    return (
                      <div 
                        key={rdv.id} 
                        className={`appointment-item-mobile status-${rdv.statut}`}
                        onClick={() => handleRdvClick(rdv)}
                      >
                        <div className="appointment-date">
                          {new Date(rdv.date).toLocaleDateString('fr-FR', {day: 'numeric', month: 'short'})}
                        </div>
                        <div className="appointment-time">
                          {rdv.heure}
                        </div>
                        <div className="appointment-info">
                          <div className="patient-name">
                            {patient ? `${patient.prenom} ${patient.nom}` : rdv.patientNom}
                          </div>
                          <div className="doctor-name">
                            Dr. {medecin ? `${medecin.prenom} ${medecin.nom}` : ''}
                          </div>
                        </div>
                        <div className="appointment-status">
                          <span className={`status-badge-${rdv.statut}`}></span>
                        </div>
                      </div>
                    );
                  })
                }
                {rendezvous.filter(rdv => new Date(rdv.date) >= new Date().setHours(0,0,0,0)).length === 0 && (
                  <div className="no-appointments">
                    <p>Aucun rendez-vous à venir</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {/* Onglet Demandes Rapides */}
        {activeTab === 'demandesRapides' && (
          <div className="quick-requests-mobile">
            <RenderDemandesRapides />
          </div>
        )}

        {/* Onglet Archives */}
        {activeTab === 'archives' && (
          <div>
            {showArchiveForm && (
              <div className="form-card-mobile">
                <h5>{currentArchive ? "Modifier l'archive" : "Ajouter une archive"}</h5>
                <form onSubmit={handleAddArchive}>
                  <div className="form-group-mobile">
                    <label className="form-label">Patient</label>
                    <select 
                      name="patientId" 
                      className="form-select" 
                      value={archiveForm.patientId} 
                      onChange={handleArchiveChange}
                      required
                    >
                      <option value="">Sélectionner un patient</option>
                      {patients.map(patient => (
                        <option key={patient.id} value={patient.id}>
                          {patient.prenom} {patient.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Titre</label>
                    <input 
                      type="text" 
                      name="titre" 
                      className="form-control" 
                      value={archiveForm.titre} 
                      onChange={handleArchiveChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Description</label>
                    <textarea 
                      name="description" 
                      className="form-control" 
                      value={archiveForm.description} 
                      onChange={handleArchiveChange}
                      rows="3"
                    />
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Notes</label>
                    <textarea 
                      name="notes" 
                      className="form-control" 
                      value={archiveForm.notes} 
                      onChange={handleArchiveChange}
                      rows="3"
                    />
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Date</label>
                    <input 
                      type="date" 
                      name="date" 
                      className="form-control" 
                      value={archiveForm.date} 
                      onChange={handleArchiveChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Tags</label>
                    <div className="tags-selector">
                      {tagsList.map(tag => (
                        <div className="tag-option" key={tag}>
                          <input 
                            type="checkbox" 
                            id={`tag-${tag}`} 
                            name="tags" 
                            value={tag}
                            checked={archiveForm.tags.includes(tag)}
                            onChange={handleArchiveChange}
                          />
                          <label htmlFor={`tag-${tag}`}>
                            {tag}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="form-group-mobile">
                    <label className="form-label">Fichiers</label>
                    <input 
                      type="file" 
                      className="form-control" 
                      onChange={handleFileChange}
                      multiple
                    />
                    <div className="form-text">
                      Vous pouvez sélectionner plusieurs fichiers.
                    </div>
                  </div>
                  
                  {selectedFiles.length > 0 && (
                    <div className="selected-files-mobile">
                      <h6>Fichiers sélectionnés:</h6>
                      <div className="files-list">
                        {selectedFiles.map((file, index) => (
                          <div key={index} className="file-item">
                            <div className="file-name">{file.name}</div>
                            <div className="file-size">{(file.size / 1024).toFixed(2)} KB</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {currentArchive && archiveForm.files && archiveForm.files.length > 0 && (
                    <div className="form-group-mobile">
                      <label className="form-label">Fichiers existants</label>
                      <div className="files-grid-mobile">
                        {archiveForm.files.map((file, index) => (
                          <div key={index} className="file-card-mobile">
                            <div 
                              className="file-preview"
                              onClick={() => {
                                setSelectedFile(file);
                                setShowFilePreview(true);
                              }}
                            >
                              {getFileType(file) === 'image' ? (
                                <img 
                                  src={file.url} 
                                  alt={file.name} 
                                  className="img-fluid" 
                                />
                              ) : (
                                <div className="file-icon">
                                  <FontAwesomeIcon 
                                    icon={
                                      getFileType(file) === 'pdf' ? faFilePdf :
                                      getFileType(file) === 'word' ? faFileWord :
                                      getFileType(file) === 'excel' ? faFileExcel :
                                      getFileType(file) === 'video' ? faVideo :
                                      getFileType(file) === 'audio' ? faMusic :
                                      faFile
                                    } 
                                  />
                                </div>
                              )}
                            </div>
                            <div className="file-info">
                              <div className="file-name">{file.name}</div>
                              <div className="file-actions">
                                <button 
                                  type="button" 
                                  className="btn-icon"
                                  onClick={() => {
                                    setSelectedFile(file);
                                    setShowFilePreview(true);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </button>
                                <button 
                                  type="button" 
                                  className="btn-icon danger"
                                  onClick={() => handleDeleteFile(currentArchive.id, file, index)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <div className="action-container-mobile">
                    <button type="button" className="btn btn-secondary btn-block mb-2" onClick={() => {
                      resetArchiveForm();
                      setShowArchiveForm(false);
                    }}>
                      <FontAwesomeIcon icon={faTimes} className="me-2" />
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-primary btn-block">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      {currentArchive ? "Mettre à jour" : "Ajouter"}
                    </button>
                  </div>
                </form>
              </div>
            )}
            
            {/* Recherche et liste des archives */}
            <div className="search-box-mobile">
              <input 
                type="text" 
                className="form-control" 
                placeholder="Rechercher un patient" 
                value={filtreArchivePatient}
                onChange={(e) => setFiltreArchivePatient(e.target.value)}
              />
              <button className="btn-search">
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
            
            <div className="archives-list-mobile">
              {archives.length > 0 ? (
                archives
                  .filter(archive => {
                    if (!filtreArchivePatient) return true;
                    const patientNom = archive.patientNom || '';
                    return patientNom.toLowerCase().includes(filtreArchivePatient.toLowerCase());
                  })
                  .map(archive => (
                    <div key={archive.id} className="archive-item-mobile">
                      <div className="archive-header">
                        <h6>{archive.titre}</h6>
                        <div className="archive-date">
                          {new Date(archive.date).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="archive-content">
                        <div className="archive-patient">
                          <FontAwesomeIcon icon={faUser} className="me-2" />
                          {archive.patientNom}
                        </div>
                        <div className="archive-tags">
                          {archive.tags && archive.tags.map((tag, index) => (
                            <span key={index} className="tag">{tag}</span>
                          ))}
                        </div>
                        {archive.files && archive.files.length > 0 && (
                          <div className="archive-files">
                            <FontAwesomeIcon icon={faPaperclip} className="me-2" />
                            {archive.files.length} fichier(s)
                          </div>
                        )}
                      </div>
                      <div className="archive-actions">
                        <button 
                          className="btn-icon"
                          onClick={() => handleEditArchive(archive)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button 
                          className="btn-icon danger"
                          onClick={() => handleDeleteArchive(archive.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="empty-state">
                  <p>Aucune archive n'a été ajoutée</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetArchiveForm();
                      setShowArchiveForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Ajouter une archive
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Modales pour la version mobile */}
    <Modal show={showDateModal} onHide={() => setShowDateModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Rendez-vous du {selectedDate && selectedDate.date.toLocaleDateString()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="list-group">
          {selectedDate && getMedecinsByDate(selectedDate).map((item, index) => (
            <button 
              key={index} 
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              onClick={() => handleMedecinClick(item.medecin.id)}
            >
              <div>
                <h6>Dr. {item.medecin.prenom} {item.medecin.nom}</h6>
                <p className="mb-0 small text-muted">{item.medecin.specialite}</p>
              </div>
              <span className="badge bg-primary rounded-pill">{item.rdvCount}</span>
            </button>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={() => setShowDateModal(false)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>

    <Modal show={showMedecinRdvModal} onHide={() => setShowMedecinRdvModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedMedecinId && selectedDate && (
            <>
              <div>Dr. {medecins.find(m => m.id === selectedMedecinId)?.prenom} {medecins.find(m => m.id === selectedMedecinId)?.nom}</div>
              <div className="small text-muted">
                {selectedDate.date.toLocaleDateString()}
              </div>
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="rdv-list-mobile">
          {selectedMedecinId && selectedDate && getMedecinRdvs(selectedMedecinId, selectedDate).map((rdv) => (
            <div 
              key={rdv.id} 
              className={`rdv-item-mobile status-${rdv.statut}`}
              onClick={() => handleRdvClick(rdv)}
            >
              <div className="rdv-time-mobile">
                {rdv.heure}
              </div>
              <div className="rdv-patient-mobile">
                {patients.find(p => p.id === rdv.patientId)?.prenom} {patients.find(p => p.id === rdv.patientId)?.nom || rdv.patientNom}
              </div>
              <div className="rdv-actions-mobile">
                <button 
                  className="btn-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditRendezvous(rdv);
                    setShowMedecinRdvModal(false);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button 
                  className="btn-icon danger"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (window.confirm('Supprimer ce rendez-vous ?')) {
                      handleDeleteRendezvous(rdv.id);
                      setShowMedecinRdvModal(false);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          ))}
        </div>
     
      </Modal.Body>
    </Modal>

    <Modal show={showFilePreview} onHide={() => setShowFilePreview(false)} centered fullscreen>
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedFile?.name || 'Prévisualisation'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 file-preview-modal">
        {selectedFile && renderFilePreview(selectedFile)}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="primary" 
          href={selectedFile?.url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn-block"
        >
          <FontAwesomeIcon icon={faDownload} className="me-2" />
          Télécharger
        </Button>
      </Modal.Footer>
    </Modal>
    <style jsx >
{`
/* Styles généraux pour mobile */
.dashboard-container.mobile {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  font-size: 14px;
}

/* Barre de navigation mobile */
.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.mobile-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.menu-toggle {
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  padding: 5px;
}

/* Menu latéral en version mobile */
.sidebar-mobile {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 85%;
  background-color: #fff;
  z-index: 999;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
}

.sidebar-mobile.visible {
  transform: translateX(0);
}

.sidebar-mobile.hidden {
  transform: translateX(-100%);
}

.sidebar-menu-mobile ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu-mobile li {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}

.sidebar-menu-mobile li.active {
  background-color: #f8f9fa;
  border-left: 4px solid #0d6efd;
}

.sidebar-menu-mobile li svg {
  margin-right: 15px;
  width: 20px;
}

.sidebar-menu-mobile .badge {
  margin-left: auto;
  font-size: 12px;
}

.badge-container {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.quick-badge {
  margin-left: 5px;
}

/* Contenu principal */
.main-content-mobile {
  margin-top: 60px;
  padding: 15px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}

/* En-tête du contenu */
.content-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.content-header-mobile h2 {
  font-size: 20px;
  margin: 0;
}

/* Bouton flottant d'action */
.btn-floating {
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 30px;
  top:15px;
  left:67px;
  height: 30px;
  border-radius: 50%;
  background-color: #0d6efd;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 3px 5px rgba(0,0,0,0.2);
  font-size: 20px;
  z-index: 100;
}

/* Styles des cartes */
.card-mobile {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  margin-bottom: 15px;
  overflow: hidden;
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.card-header-mobile h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.card-content-mobile {
  padding: 15px;
}

.card-content-mobile p {
  margin-bottom: 8px;
}

.card-actions-mobile {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  border-top: 1px solid #f0f0f0;
}

/* Grille de cartes */
.cards-grid-mobile {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Formulaires */
.form-card-mobile {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  margin-bottom: 15px;
  padding: 15px;
}

.form-card-mobile h5 {
  margin-bottom: 15px;
  font-size: 18px;
}

.form-group-mobile {
  margin-bottom: 15px;
}

.form-group-mobile label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.action-container-mobile {
  margin-top: 20px;
}

.btn-block {
  display: block;
  width: 100%;
}

/* Calendrier mobile */
.calendar-mobile {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  margin-bottom: 15px;
  overflow: hidden;
}

.calendar-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: #f8f9fa;
}

.calendar-header-mobile h5 {
  margin: 0;
  font-size: 16px;
}

.calendar-days-mobile {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.calendar-day-header {
  padding: 8px 0;
  font-weight: 600;
  font-size: 12px;
}

.calendar-grid-mobile {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.calendar-day-mobile {
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #f0f0f0;
  position: relative;
}

.calendar-day-mobile.other-month {
  color: #ccc;
}

.calendar-day-mobile.has-events {
  font-weight: 600;
}

.day-number {
  font-size: 14px;
}

.event-dot {
  position: absolute;
  bottom: 5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #0d6efd;
}

/* Liste des rendez-vous */
.day-appointments-mobile {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  margin-top: 15px;
  padding: 15px;
}

.day-appointments-mobile h6 {
  margin-bottom: 10px;
}

.appointments-list-mobile {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.appointment-item-mobile {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f8f9fa;
  position: relative;
}

.appointment-item-mobile.status-confirme {
  border-left: 4px solid #198754;
}

.appointment-item-mobile.status-annule {
  border-left: 4px solid #dc3545;
}

.appointment-item-mobile.status-attente {
  border-left: 4px solid #ffc107;
}

.appointment-date {
  min-width: 50px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
}

.appointment-time {
  min-width: 45px;
  text-align: center;
  font-weight: 600;
  padding: 0 5px;
}

.appointment-info {
  flex-grow: 1;
  padding: 0 10px;
  overflow: hidden;
}

.patient-name {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doctor-name {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.appointment-status {
  width: 10px;
  display: flex;
  align-items: center;
}

.status-badge-confirme {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #198754;
}

.status-badge-annule {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #dc3545;
}

.status-badge-attente {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffc107;
}

.no-appointments {
  text-align: center;
  padding: 20px 0;
  color: #6c757d;
}

/* Créneaux horaires */
.time-slots-mobile {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 5px;
}

.time-slot {
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #dee2e6;
  min-width: 60px;
  text-align: center;
  font-size: 13px;
  position: relative;
  cursor: pointer;
}

.time-slot.libre {
  background-color: #d1e7dd;
  border-color: #badbcc;
}

.time-slot.partiel {
  background-color: #fff3cd;
  border-color: #ffecb5;
}

.time-slot.complet {
  background-color: #f8d7da;
  border-color: #f5c2c7;
  opacity: 0.7;
  cursor: not-allowed;
}

.time-slot.selected {
  border: 2px solid #0d6efd;
  font-weight: 600;
}

.slot-info {
  font-size: 10px;
  margin-top: 3px;
}

/* Liste des archives */
.search-box-mobile {
  position: relative;
  margin-bottom: 15px;
}

.search-box-mobile input {
  padding-right: 40px;
}

.btn-search {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.archives-list-mobile {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.archive-item-mobile {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  overflow: hidden;
}

.archive-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.archive-header h6 {
  margin: 0;
  font-weight: 600;
}

.archive-date {
  font-size: 12px;
  color: #6c757d;
}

.archive-content {
  padding: 15px;
}

.archive-patient {
  margin-bottom: 10px;
  font-weight: 500;
}

.archive-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
}

.archive-files {
  font-size: 13px;
  color: #6c757d;
}

.archive-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  border-top: 1px solid #f0f0f0;
}

/* Boutons d'action */
.btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212529;
  margin-left: 5px;
  cursor: pointer;
}

.btn-icon.danger {
  color: #dc3545;
}

/* Tags */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}

.tag {
  background-color: #f0f0f0;
  color: #333;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 15px;
  display: inline-block;
}

.tags-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-option {
  position: relative;
}

.tag-option input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.tag-option label {
  display: inline-block;
  padding: 5px 10px;
  background-color: #f0f0f0;
  border-radius: 15px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.tag-option input:checked + label {
  background-color: #0d6efd;
  color: white;
}

/* Grille d'assurances */
.assurances-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

/* Fichiers */
.files-grid-mobile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.file-card-mobile {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
}

.file-preview {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  overflow: hidden;
}

.file-preview img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.file-icon {
  font-size: 30px;
  color: #6c757d;
}

.file-info {
  padding: 8px;
}

.file-name {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
}

.file-actions {
  display: flex;
  justify-content: space-between;
}

.selected-files-mobile {
  margin-bottom: 15px;
}

.files-list {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 10px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #dee2e6;
}

.file-item:last-child {
  border-bottom: none;
}

.file-size {
  font-size: 12px;
  color: #6c757d;
}

/* Prévisualisation des fichiers */
.file-preview-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  min-height: 300px;
}

/* État vide */
.empty-state {
  text-align: center;
  padding: 30px 15px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.empty-state p {
  color: #6c757d;
  margin-bottom: 15px;
}

/* Liste des RDV dans la modale */
.rdv-list-mobile {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rdv-item-mobile {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  background-color: #f8f9fa;
  border-left: 4px solid transparent;
}

.rdv-item-mobile.status-confirme {
  border-left-color: #198754;
}

.rdv-item-mobile.status-annule {
  border-left-color: #dc3545;
}

.rdv-item-mobile.status-attente {
  border-left-color: #ffc107;
}

.rdv-time-mobile {
  font-weight: 600;
  min-width: 50px;
}

.rdv-patient-mobile {
  flex-grow: 1;
  padding: 0 10px;
}

.rdv-actions-mobile {
  display: flex;
  gap: 5px;
}

/* Demandes rapides */
.quick-requests-mobile {
  padding-bottom: 70px; /* Espace pour le bouton flottant */
}

/* Accordion pour les disponibilités */
.accordion-button {
  padding: 10px 15px;
  font-size: 14px;
}

.accordion-body {
  padding: 10px;
}


`}
    </style>
  </div>
);

                    

};


 return (
    <div className="dashboard-container">
      {/* Menu latéral */}
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>{!sidebarCollapsed && structureData.nom}</h3>
          <button className="toggle-btn" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={sidebarCollapsed ? faChevronRight : faChevronLeft} />
          </button>
        </div>
        
        <div className="sidebar-menu">
          <ul>
            <li className={activeTab === 'info' ? 'active' : ''} onClick={() => setActiveTab('info')}>
              <FontAwesomeIcon icon={faHome} />
              {!sidebarCollapsed && <span>Informations</span>}
            </li>
            <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => setActiveTab('affiliations')}>
              <FontAwesomeIcon icon={faLink} />
              {!sidebarCollapsed && <span>Affiliations</span>}
              {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0) > 0 && (
                <span className="badge bg-danger">
                  {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0)}
                </span>
              )}
            </li>
            <li className={activeTab === 'medecins' ? 'active' : ''} onClick={() => setActiveTab('medecins')}>
              <FontAwesomeIcon icon={faUserMd} />
              {!sidebarCollapsed && <span>Médecins</span>}
              <span className="badge bg-info">{medecins.length}</span>
            </li>
            <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => setActiveTab('patients')}>
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Patients</span>}
              <span className="badge bg-info">{patients.length}</span>
            </li>
            <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => setActiveTab('rendezvous')}>
  <FontAwesomeIcon icon={faCalendarAlt} />
  {!sidebarCollapsed && <span>Rendez-vous</span>}
  <div className="badge-container">
    <span className="badge bg-info">{rendezvous.length}</span>
    {quickRequestsCount > 0 && (
      <span className="badge bg-danger quick-badge">{quickRequestsCount}</span>
    )}
  </div>
</li>

<li className={activeTab === 'archives' ? 'active' : ''} onClick={() => setActiveTab('archives')}>
      <FontAwesomeIcon icon={faArchive} />
      {!sidebarCollapsed && <span>Archives</span>}
      <span className="badge bg-info">{archives.length}</span>
    </li>
    
            <li className={activeTab === 'demandesRapides' ? 'active' : ''} onClick={() => setActiveTab('demandesRapides')}>
              <FontAwesomeIcon icon={faBolt} />
              {!sidebarCollapsed && <span>Rendez-vous rapides</span>}
              <div className="badge-container">
                <span className="badge bg-warning ms-2">{demandesRapides.length}</span>
              </div>
            </li>
            <li onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {!sidebarCollapsed && <span>Déconnexion</span>}
            </li>
          </ul>
        </div>
      </div>

      {/* Contenu principal */}
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        {/* En-tête avec le titre de la section active */}
        <div className="content-header">
          <h2>
            {activeTab === 'info' && 'Informations de la structure'}
            {activeTab === 'affiliations' && 'Gestion des affiliations'}
            {activeTab === 'medecins' && 'Gestion des médecins'}
            {activeTab === 'patients' && 'Gestion des patients'}
            {activeTab === 'rendezvous' && 'Gestion des rendez-vous'}
            {activeTab === 'archives' && 'Archives des patients'}
            {activeTab === 'password' && 'Modification du mot de passe'}
            {activeTab === 'demandesRapides'}
          </h2>
          
          {/* Boutons d'action spécifiques à chaque onglet */}
          <div className="action-buttons">
            {activeTab === 'medecins' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetMedecinForm();
                  setShowMedecinForm(!showMedecinForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showMedecinForm ? 'Annuler' : 'Ajouter un médecin'}
              </button>
            )}
            
            {activeTab === 'patients' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetPatientForm();
                  setShowPatientForm(!showPatientForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showPatientForm ? 'Annuler' : 'Ajouter un patient'}
              </button>
            )}
            
            {activeTab === 'rendezvous' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetRdvForm();
                  setShowRendezvousForm(!showRendezvousForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showRendezvousForm ? 'Annuler' : 'Ajouter un rendez-vous'}
              </button>
            )}
            
            {activeTab === 'archives' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetArchiveForm();
                  setShowArchiveForm(!showArchiveForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showArchiveForm ? 'Annuler' : 'Ajouter une archive'}
              </button>
            )}
          </div>
        </div>

        {/* Affichage des messages de notification */}
        {message && (
          <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}

        {/* Contenu des différents onglets */}
        <div className="content-body">
          {/* Onglet Informations */}
          {activeTab === 'info' && (
  <div className="card shadow-sm">
    <div className="card-body">
      <div className="form-mobile">
        {Object.keys(form).map((key) => {
          if (key === 'createdAt' || key === 'updatedAt') {
            return null;
          }
          
          // Traitement spécial pour les spécialités
          if (key === 'specialites') {
            return (
              <div className="form-group-mobile" key={key}>
                <label className="form-label">Spécialités</label>
                <div className="badge-container">
                  {form.specialites && form.specialites.length > 0 ? (
                    form.specialites.map(specialite => (
                      <span key={specialite} className="badge bg-primary m-1">{specialite}</span>
                    ))
                  ) : (
                    <span className="text-muted">Aucune spécialité sélectionnée</span>
                  )}
                </div>
                <div className="specialty-checkboxes mt-2">
                  {specialites.map(specialite => (
                    <div key={specialite} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`specialite-${specialite}`}
                        value={specialite}
                        checked={form.specialites?.includes(specialite) || false}
                        onChange={(e) => {
                          const { checked, value } = e.target;
                          let updatedSpecialites = [...(form.specialites || [])];
                          if (checked) {
                            updatedSpecialites.push(value);
                          } else {
                            updatedSpecialites = updatedSpecialites.filter(s => s !== value);
                          }
                          setForm({ ...form, specialites: updatedSpecialites });
                        }}
                      />
                      <label className="form-check-label" htmlFor={`specialite-${specialite}`}>
                        {specialite}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          
          // Traitement spécial pour les assurances
          if (key === 'assurances') {
            return (
              <div className="form-group-mobile" key={key}>
                <label className="form-label">Assurances acceptées</label>
                <div className="badge-container">
                  {form.assurances && form.assurances.length > 0 ? (
                    form.assurances.map(assurance => (
                      <span key={assurance} className="badge bg-success m-1">{assurance}</span>
                    ))
                  ) : (
                    <span className="text-muted">Aucune assurance sélectionnée</span>
                  )}
                </div>
                <div className="insurance-checkboxes mt-2">
                  {assurancesList.map(assurance => (
                    <div key={assurance} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`assurance-${assurance}`}
                        value={assurance}
                        checked={form.assurances?.includes(assurance) || false}
                        onChange={(e) => {
                          const { checked, value } = e.target;
                          let updatedAssurances = [...(form.assurances || [])];
                          if (checked) {
                            updatedAssurances.push(value);
                          } else {
                            updatedAssurances = updatedAssurances.filter(a => a !== value);
                          }
                          setForm({ ...form, assurances: updatedAssurances });
                        }}
                      />
                      <label className="form-check-label" htmlFor={`assurance-${assurance}`}>
                        {assurance}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          
          // Pour les autres champs, conserver le comportement actuel
          return (
            <div className="form-group-mobile" key={key}>
              <label className="form-label">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
              <input
                name={key}
                value={form[key] || ''}
                onChange={handleChange}
                className="form-control"
                placeholder={key}
              />
            </div>
          );
        })}
      </div>
      <div className="action-container-mobile">
        <button onClick={handleUpdate} className="btn btn-primary btn-block">
          <FontAwesomeIcon icon={faCheck} className="me-2" />
          Mettre à jour
        </button>
      </div>
    </div>
  </div>
)}

          {/* Onglet Affiliations */}
          {activeTab === 'affiliations' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <AffiliationRequestsManager onRequestProcessed={fetchPendingRequests} />
              </div>
            </div>
          )}

          {/* Onglet Médecins - Affichage en mode carte */}
          {activeTab === 'medecins' && (
            <div>
              {showMedecinForm && (
                <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentMedecin ? 'Modifier le médecin' : 'Ajouter un médecin'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddMedecin}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input
                          type="text"
                          name="nom"
                          className="form-control"
                          value={medecinForm.nom}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom</label>
                        <input
                          type="text"
                          name="prenom"
                          className="form-control"
                          value={medecinForm.prenom}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Spécialité</label>
                        <select
                          name="specialite"
                          className="form-select"
                          value={medecinForm.specialite}
                          onChange={handleMedecinChange}
                          required
                        >
                          <option value="">Sélectionner une spécialité</option>
                          {specialites.map((spec) => (
                            <option key={spec} value={spec}>{spec}</option>
                          ))}
                        </select>
                        {medecinForm.specialite === 'Autre' && (
                          <input
                            type="text"
                            name="specialiteAutre"
                            className="form-control mt-2"
                            placeholder="Précisez la spécialité"
                            value={medecinForm.specialiteAutre || ''}
                            onChange={handleMedecinChange}
                          />
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="form-control"
                          value={medecinForm.telephone}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={medecinForm.email}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                    
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Disponibilités</label>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Jour</th>
                              <th>Disponible</th>
                              <th>Heure de début</th>
                              <th>Heure de fin</th>
                            </tr>
                          </thead>
                          <tbody>
                            {joursSemaine.map((jour) => (
                              <tr key={jour}>
                                <td>{jour.charAt(0).toUpperCase() + jour.slice(1)}</td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`disponible-${jour}`}
                                      checked={medecinForm.disponibilites[jour].actif}
                                      onChange={() => handleDisponibiliteChange(jour, 'actif')}
                                    />
                                    <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                                      {medecinForm.disponibilites[jour].actif ? 'Oui' : 'Non'}
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    className="form-control"
                                    value={medecinForm.disponibilites[jour].debut}
                                    onChange={(e) => handleDisponibiliteChange(jour, 'debut', e.target.value)}
                                    disabled={!medecinForm.disponibilites[jour].actif}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    className="form-control"
                                    value={medecinForm.disponibilites[jour].fin}
                                    onChange={(e) => handleDisponibiliteChange(jour, 'fin', e.target.value)}
                                    disabled={!medecinForm.disponibilites[jour].actif}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Assurances acceptées</label>
                      <div className="d-flex flex-wrap">
                        {assurancesList.map((assurance) => (
                          <div className="form-check me-3 mb-2" key={assurance}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-medecin-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={medecinForm.assurances.includes(assurance)}
                              onChange={handleMedecinChange}
                            />
                            <label className="form-check-label" htmlFor={`assurance-medecin-${assurance}`}>
                              {assurance}
                            </label>
                          </div>
                        ))}
                      </div>
                      {medecinForm.assurances.includes('Autre') && (
                        <input
                          type="text"
                          name="assuranceAutre"
                          className="form-control mt-2"
                          placeholder="Précisez l'assurance"
                          value={medecinForm.assuranceAutre || ''}
                          onChange={handleMedecinChange}
                        />
                      )}
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetMedecinForm();
                        setShowMedecinForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentMedecin ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Liste des médecins en mode carte */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {medecins.length > 0 ? (
                medecins.map((medecin) => (
                  <div className="col" key={medecin.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title">Dr. {medecin.prenom} {medecin.nom}</h5>
                          <span className="badge bg-info">{medecin.specialite}</span>
                        </div>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                          {medecin.telephone}
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                          {medecin.email}
                        </p>
                        <div className="mt-3">
                          <h6>Disponibilités:</h6>
                          <div className="disponibilites-container">
                            {Array.isArray(medecin.disponibilites) ? (
                              medecin.disponibilites.map((dispo, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {dispo.jour}: {dispo.heureDebut}-{dispo.heureFin}
                                </span>
                              ))
                            ) : (
                              Object.entries(medecin.disponibilites || {}).map(([jour, dispo]) => (
                                dispo.actif && (
                                  <span key={jour} className="badge bg-light text-dark me-1 mb-1">
                                    {jour.charAt(0).toUpperCase() + jour.slice(1)}: {dispo.debut}-{dispo.fin}
                                  </span>
                                )
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer bg-transparent border-top-0">
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEditMedecin(medecin)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDeleteMedecin(medecin.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p className="text-muted">Aucun médecin n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetMedecinForm();
                      setShowMedecinForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                    Ajouter un médecin
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Patients - Affichage en mode carte */}
        {activeTab === 'patients' && (
          <div>
            {showPatientForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentPatient ? 'Modifier le patient' : 'Ajouter un patient'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddPatient}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input
                          type="text"
                          name="nom"
                          className="form-control"
                          value={patientForm.nom}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom</label>
                        <input
                          type="text"
                          name="prenom"
                          className="form-control"
                          value={patientForm.prenom}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Date de naissance</label>
                        <input
                          type="date"
                          name="dateNaissance"
                          className="form-control"
                          value={patientForm.dateNaissance}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="form-control"
                          value={patientForm.telephone}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={patientForm.email}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                    
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Assurances</label>
                      <div className="d-flex flex-wrap">
                        {assurancesList.map((assurance) => (
                          <div className="form-check me-3 mb-2" key={assurance}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-patient-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={patientForm.assurances.includes(assurance)}
                              onChange={handlePatientChange}
                            />
                            <label className="form-check-label" htmlFor={`assurance-patient-${assurance}`}>
                              {assurance}
                            </label>
                          </div>
                        ))}
                      </div>
                      {patientForm.assurances.includes('Autre') && (
                        <input
                          type="text"
                          name="assuranceAutre"
                          className="form-control mt-2"
                          placeholder="Précisez l'assurance"
                          value={patientForm.assuranceAutre || ''}
                          onChange={handlePatientChange}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Diagnostics</label>
                      <textarea
                        name="diagnostics"
                        className="form-control"
                        value={patientForm.diagnostics}
                        onChange={handlePatientChange}
                        rows="3"
                        placeholder="Entrez les diagnostics du patient"
                      />
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetPatientForm();
                        setShowPatientForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentPatient ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Liste des patients en mode carte */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {patients.length > 0 ? (
                patients.map((patient) => (
                  <div className="col" key={patient.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title">{patient.prenom} {patient.nom}</h5>
                          <span className="badge bg-secondary">
                            {new Date().getFullYear() - new Date(patient.dateNaissance).getFullYear()} ans
                          </span>
                        </div>
                        <p className="card-text">
                          <small className="text-muted">Né(e) le {new Date(patient.dateNaissance).toLocaleDateString()}</small>
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                          {patient.telephone}
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                          {patient.email}
                        </p>
                        <div className="mt-3">
                          <h6>Assurances:</h6>
                          <div>
                            {patient.assurances && patient.assurances.map((assurance, index) => (
                              <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                {assurance}
                              </span>
                            ))}
                          </div>
                        </div>
                        {patient.diagnostics && (
                          <div className="mt-3">
                            <h6>Diagnostics:</h6>
                            <p className="text-muted">{patient.diagnostics}</p>
                          </div>
                        )}
                      </div>
                      <div className="card-footer bg-transparent border-top-0">
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEditPatient(patient)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDeletePatient(patient.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p className="text-muted">Aucun patient n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetPatientForm();
                      setShowPatientForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                    Ajouter un patient
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Rendez-vous - Vue mensuelle */}
        {activeTab === 'rendezvous' && (
          <div>
            {showRendezvousForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentRendezvous ? 'Modifier le rendez-vous' : 'Ajouter un rendez-vous'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddRendezvous}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Médecin</label>
                        <select
                          name="medecinId"
                          className="form-select"
                          value={rdvForm.medecinId}
                          onChange={handleRdvChange}
                          required
                        >
                          <option value="">Sélectionner un médecin</option>
                          {medecins.map((medecin) => (
                            <option key={medecin.id} value={medecin.id}>
                              Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Patient</label>
                        <select
                          name="patientId"
                          className="form-select"
                          value={rdvForm.patientId}
                          onChange={handleRdvChange}
                          required
                        >
                          <option value="">Sélectionner un patient</option>
                          {patients.map((patient) => (
                            <option key={patient.id} value={patient.id}>
                              {patient.prenom} {patient.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label className="form-label">Date</label>
                        <input
                          type="date"
                          name="date"
                          className="form-control"
                          value={rdvForm.date}
                          onChange={handleRdvChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
  <label className="form-label">Heure</label>
  <div className="time-slots-container">
    {rdvForm.medecinId && rdvForm.date ? (
      getCreneauxAvecStatut().map((creneau) => (
        <div 
          key={creneau.heure}
          className={`time-slot ${creneau.statut} ${rdvForm.heure === creneau.heure ? 'selected' : ''}`}
          onClick={() => {
            if (creneau.statut !== 'complet') {
              setRdvForm({...rdvForm, heure: creneau.heure});
            }
          }}
        >
          {creneau.heure}
          {creneau.statut === 'partiel' && (
            <div className="slot-info">
              {creneau.nombreRdv}/{3} occupé{creneau.nombreRdv > 1 ? 's' : ''}
            </div>
          )}
          {creneau.statut === 'complet' && (
            <div className="slot-info">Complet</div>
          )}
        </div>
      ))
    ) : (
      <div className="alert alert-info">
        Veuillez sélectionner un médecin et une date
      </div>
    )}
  </div>
</div>


                  {/*  <div className="col-md-4 mb-3">
                        <label className="form-label">Durée (minutes)</label>
                        <select
                          name="duree"
                          className="form-select"
                          value={rdvForm.duree}
                          onChange={handleRdvChange}
                          required
                        >
                          {dureesRdv.map((duree) => (
                            <option key={duree} value={duree}>
                              {duree} min
                            </option>
                          ))}
                        </select>
                      </div> */}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Motif</label>
                        <textarea
                          name="motif"
                          className="form-control"
                          value={rdvForm.motif}
                          onChange={handleRdvChange}
                          rows="3"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Statut</label>
                        <select
                          name="statut"
                          className="form-select"
                          value={rdvForm.statut}
                          onChange={handleRdvChange}
                          required
                        >
                          {statutsRdv.map((statut) => (
                            <option key={statut} value={statut}>
                              {statut.charAt(0).toUpperCase() + statut.slice(1)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetRdvForm();
                        setShowRendezvousForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentRendezvous ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}



            {/* Vue calendrier des rendez-vous */}
            <div className="card shadow-sm mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={handlePrevMonth}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <h5 className="mb-0 mx-3">
                    {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                  </h5>
                  <button className="btn btn-sm btn-outline-secondary ms-2" onClick={handleNextMonth}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
                <div className="d-flex align-items-center">
                  <h5 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                    Calendrier des rendez-vous
                  </h5>
                  <Button 
                    variant="outline-warning" 
                    onClick={sendAppointmentReminders}
                    disabled={loading}
                  >
                    <FontAwesomeIcon icon={loading ? faSpinner : faBell} className={loading ? "fa-spin me-2" : "me-2"} />
                    Envoyer les rappels de demain
                  </Button>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="calendar-container">
                  <div className="calendar-header">
                    {['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map((day, index) => (
                      <div key={index} className="calendar-cell header">
                        {day}
                      </div>
                    ))}
                  </div>
                  <div className="calendar-body">
                    {getMonthData().map((day, index) => (
                      <div 
                        key={index} 
                        className={`calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                        onClick={() => handleDateClick(day)}
                      >
                        <div className="date-number">{day.date.getDate()}</div>
                        {day.hasEvents && (
                          <div className="event-indicator">
                            <span className="badge rounded-pill bg-primary">
                              {day.medecinCount} {day.medecinCount > 1 ? 'médecins' : 'médecin'}
                            </span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
 {activeTab === 'demandesRapides' && (
          <div>

             <RenderDemandesRapides />
          </div>
        ) }

        {/* Onglet Archives */}
        {activeTab === 'archives' && (
          <div>
            {showArchiveForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentArchive ? "Modifier l'archive" : "Ajouter une archive"}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddArchive}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="patientId" className="form-label">Patient</label>
                        <select 
                          id="patientId" 
                          name="patientId" 
                          className="form-select" 
                          value={archiveForm.patientId} 
                          onChange={handleArchiveChange}
                          required
                        >
                          <option value="">Sélectionner un patient</option>
                          {patients.map(patient => (
                            <option key={patient.id} value={patient.id}>
                              {patient.prenom} {patient.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="titre" className="form-label">Titre</label>
                        <input 
                          type="text" 
                          id="titre" 
                          name="titre" 
                          className="form-control" 
                          value={archiveForm.titre} 
                          onChange={handleArchiveChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="description" className="form-label">Description</label>
                        <textarea 
                          id="description" 
                          name="description" 
                          className="form-control" 
                          value={archiveForm.description} 
                          onChange={handleArchiveChange}
                          rows="3"
                        />
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <textarea 
                          id="notes" 
                          name="notes" 
                          className="form-control" 
                          value={archiveForm.notes} 
                          onChange={handleArchiveChange}
                          rows="3"
                          />
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date" className="form-label">Date</label>
                          <input 
                            type="date" 
                            id="date" 
                            name="date" 
                            className="form-control" 
                            value={archiveForm.date} 
                            onChange={handleArchiveChange}
                            required
                          />
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Tags</label>
                          <div className="d-flex flex-wrap">
                            {tagsList.map(tag => (
                              <div className="form-check me-3 mb-2" key={tag}>
                                <input 
                                  type="checkbox" 
                                  className="form-check-input" 
                                  id={`tag-${tag}`} 
                                  name="tags" 
                                  value={tag}
                                  checked={archiveForm.tags.includes(tag)}
                                  onChange={handleArchiveChange}
                                />
                                <label className="form-check-label" htmlFor={`tag-${tag}`}>
                                  {tag}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="files" className="form-label">Fichiers</label>
                        <input 
                          type="file" 
                          id="files" 
                          className="form-control" 
                          onChange={handleFileChange}
                          multiple
                        />
                        <div className="form-text">
                          Vous pouvez sélectionner plusieurs fichiers.
                        </div>
                      </div>
                      
                      {selectedFiles.length > 0 && (
                        <div className="mb-3">
                          <h6>Fichiers sélectionnés :</h6>
                          <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                              <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                {file.name}
                                <span className="badge bg-primary rounded-pill">{(file.size / 1024).toFixed(2)} KB</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      {currentArchive && archiveForm.files && archiveForm.files.length > 0 && (
                        <div className="mb-3">
                          <label className="form-label">Fichiers existants</label>
                          <div className="row g-2">
                            {archiveForm.files.map((file, index) => (
                              <div key={index} className="col-md-4 col-6">
                                <div className="card h-100">
                                  <div 
                                    className="card-img-top file-preview-thumbnail"
                                    onClick={() => {
                                      setSelectedFile(file);
                                      setShowFilePreview(true);
                                    }}
                                    style={{ 
                                      cursor: 'pointer',
                                      height: '120px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      background: '#f8f9fa',
                                      overflow: 'hidden'
                                    }}
                                  >
                                    {getFileType(file) === 'image' ? (
                                      <img 
                                        src={file.url} 
                                        alt={file.name} 
                                        className="img-fluid" 
                                        style={{ maxHeight: '100%', maxWidth: '100%' }}
                                      />
                                    ) : (
                                      <div className="text-center">
                                        <FontAwesomeIcon 
                                          icon={
                                            getFileType(file) === 'pdf' ? faFilePdf :
                                            getFileType(file) === 'word' ? faFileWord :
                                            getFileType(file) === 'excel' ? faFileExcel :
                                            getFileType(file) === 'video' ? faVideo :
                                            getFileType(file) === 'audio' ? faMusic :
                                            faFile
                                          } 
                                          size="3x" 
                                          className="text-secondary mb-2"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="card-body p-2">
                                    <p className="card-text small text-truncate mb-1">{file.name}</p>
                                    <div className="d-flex justify-content-between">
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => {
                                          setSelectedFile(file);
                                          setShowFilePreview(true);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </button>
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDeleteFile(currentArchive.id, file, index)}
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      <div className="text-end mt-3">
                        <button type="button" className="btn btn-secondary me-2" onClick={() => {
                          resetArchiveForm();
                          setShowArchiveForm(false);
                        }}>
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentArchive ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              
              <div className="card shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5>Archives des patients</h5>
                  <div className="d-flex">
                    <input 
                      type="text" 
                      className="form-control form-control-sm me-2" 
                      placeholder="Rechercher un patient" 
                      value={filtreArchivePatient}
                      onChange={(e) => setFiltreArchivePatient(e.target.value)}
                    />
                    <button className="btn btn-sm btn-outline-secondary">
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {archives.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Patient</th>
                            <th>Titre</th>
                            <th>Date</th>
                            <th>Tags</th>
                            <th>Fichiers</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {archives
                            .filter(archive => {
                              if (!filtreArchivePatient) return true;
                              const patientNom = archive.patientNom || '';
                              return patientNom.toLowerCase().includes(filtreArchivePatient.toLowerCase());
                            })
                            .map(archive => (
                            <tr key={archive.id}>
                              <td>{archive.patientNom}</td>
                              <td>{archive.titre}</td>
                              <td>{new Date(archive.date).toLocaleDateString()}</td>
                              <td>
                                {archive.tags && archive.tags.map((tag, index) => (
                                  <span key={index} className="badge bg-info me-1">{tag}</span>
                                ))}
                              </td>
                              <td>
                                {archive.files && (
                                  <span className="badge bg-secondary">{archive.files.length}</span>
                                )}
                              </td>
                              <td>
                                <button 
                                  className="btn btn-sm btn-outline-primary me-1"
                                  onClick={() => handleEditArchive(archive)}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                                <button 
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDeleteArchive(archive.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted">Aucune archive n'a été ajoutée</p>
                      <button 
                        className="btn btn-primary" 
                        onClick={() => {
                          resetArchiveForm();
                          setShowArchiveForm(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        Ajouter une archive
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Onglet Mot de passe */}
          {activeTab === 'password' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modales pour la gestion des rendez-vous */}
      {/* Modal pour afficher les médecins d'une date */}
      <Modal show={showDateModal} onHide={() => setShowDateModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Rendez-vous du {selectedDate && selectedDate.date.toLocaleDateString()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {selectedDate && getMedecinsByDate(selectedDate).map((item, index) => (
              <button 
                key={index} 
                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                onClick={() => handleMedecinClick(item.medecin.id)}
              >
                <div>
                  <h5>Dr. {item.medecin.prenom} {item.medecin.nom}</h5>
                  <p className="mb-1 text-muted">{item.medecin.specialite}</p>
                </div>
                <span className="badge bg-primary rounded-pill">{item.rdvCount} RDV</span>
              </button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDateModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour afficher les rendez-vous d'un médecin à une date donnée */}
      <Modal show={showMedecinRdvModal} onHide={() => setShowMedecinRdvModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedMedecinId && selectedDate && (
              <>
                Rendez-vous de Dr. {medecins.find(m => m.id === selectedMedecinId)?.prenom} {medecins.find(m => m.id === selectedMedecinId)?.nom}
                <p className="mb-0 fs-6 text-muted">
                  {selectedDate.date.toLocaleDateString()}
                </p>
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="rdv-list">
            {selectedMedecinId && selectedDate && getMedecinRdvs(selectedMedecinId, selectedDate).map((rdv, index) => (
              <div 
                key={rdv.id} 
                className={`rdv-item ${draggedRdv?.id === rdv.id ? 'dragging' : ''} status-${rdv.statut}`}
                draggable
                onDragStart={() => handleDragStart(rdv)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => handleDrop(rdv)}
                onClick={() => handleRdvClick(rdv)}
              >
                <div className="rdv-time">
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  {rdv.heure}{/* ({rdv.duree} min) */}
                </div>
                <div className="rdv-patient">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {patients.find(p => p.id === rdv.patientId)?.prenom} {patients.find(p => p.id === rdv.patientId)?.nom || rdv.patientNom}
                </div>
                <div className="rdv-status">
                  <span className={`badge status-badge-${rdv.statut}`}>
                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                  </span>
                </div>
                <div className="rdv-actions">
                  <button className="btn btn-sm btn-outline-secondary me-1" title="Voir détails">
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-primary me-1" 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditRendezvous(rdv);
                      setShowMedecinRdvs(false);
                    }}
                    title="Modifier"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger" 
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
                        handleDeleteRendezvous(rdv.id);
                        setShowMedecinRdvs(false);
                      }
                    }}
                    title="Supprimer"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            ))}
            <div className="text-center mt-3">
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetRdvForm();
                  setRdvForm(prev => ({
                    ...prev,
                    medecinId: selectedMedecinId,
                    date: selectedDate.date.toISOString().split('T')[0]
                  }));
                  setShowAddForm(true);
                  setShowMedecinRdvs(false);
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Ajouter un rendez-vous
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div>
              <small className="text-muted">
                <FontAwesomeIcon icon={faExchangeAlt} className="me-1" />
                Glisser-déposer pour échanger des rendez-vous
              </small>
            </div>
            <Button variant="secondary" onClick={() => setShowMedecinRdvModal(false)}>
              Fermer
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal pour voir toutes les demandes rapides */}
      <Modal 
        show={showQuickRequestsModal} 
        onHide={() => setShowQuickRequestsModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {quickRequests.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>Contact</th>
                    <th>Date souhaitée</th>
                    <th>Heure</th>
                    <th>Motif</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {quickRequests.map(request => (
                    <tr key={request.id}>
                      <td>{request.prenom} {request.nom}</td>
                      <td>
                        <div>{request.telephone}</div>
                        <div><small>{request.email}</small></div>
                      </td>
                      <td>{request.dateFormatted}</td>
                      <td>{request.heureRdv}</td>
                      <td>{request.motif || "-"}</td>
                      <td>
                        <Button 
                          variant="outline-danger" 
                          size="sm" 
                          className="me-1"
                          onClick={() => handleRejectQuickRequest(request.id)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <Button 
                          variant="outline-success" 
                          size="sm"
                          onClick={() => {
                            setSelectedQuickRequest(request);
                            setAssignMedecinModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center py-4">Aucune demande de rendez-vous rapide en attente</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQuickRequestsModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour assigner un médecin à une demande */}
      <Modal 
        show={assignMedecinModal} 
        onHide={() => setAssignMedecinModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Assigner un médecin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {selectedQuickRequest && (
    <div>
      <div className="mb-3">
        <h6>Détails de la demande:</h6>
        <p><strong>Patient:</strong> {selectedQuickRequest.prenom} {selectedQuickRequest.nom}</p>
        <p><strong>Contact:</strong> {selectedQuickRequest.telephone}</p>
        {selectedQuickRequest.email && <p><strong>Email:</strong> {selectedQuickRequest.email}</p>}
        <p><strong>Date souhaitée:</strong> {selectedQuickRequest.dateFormatted}</p>
        <p><strong>Heure souhaitée:</strong> {selectedQuickRequest.heureRdv}</p>
        {selectedQuickRequest.motif && (
          <p><strong>Motif:</strong> {selectedQuickRequest.motif}</p>
        )}
      </div>
      
      <Form.Group className="mb-3">
        <Form.Label>Sélectionner un médecin</Form.Label>
        <Form.Select 
          value={selectedMedecinForQuick} 
          onChange={(e) => setSelectedMedecinForQuick(e.target.value)}
          required
        >
          <option value="">Choisir un médecin</option>
          {medecins.map(medecin => (
            <option key={medecin.id} value={medecin.id}>
              Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  )}
</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAssignMedecinModal(false)}>
            Annuler
          </Button>
          <Button 
            variant="primary" 
            onClick={handleAcceptQuickRequest}
            disabled={!selectedMedecinForQuick}
          >
            Confirmer le rendez-vous
          </Button>
        </Modal.Footer>
      </Modal>
    
       
      {/* Modal de prévisualisation des fichiers */}
      <Modal
        show={showFilePreview}
        onHide={() => setShowFilePreview(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedFile?.name || 'Prévisualisation'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedFile && renderFilePreview(selectedFile)}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowFilePreview(false)}
          >
            Fermer
          </Button>
          <Button 
            variant="primary" 
            href={selectedFile?.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            Télécharger
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );                 
 
};

export default StructureDashboard;







